var items = {
  "block.minecraft.acacia_button": "Akacia prembutono",
  "block.minecraft.acacia_door": "Akacia pordo",
  "block.minecraft.acacia_fence": "Akacia barilo",
  "block.minecraft.acacia_fence_gate": "Akacia barilpordo",
  "block.minecraft.acacia_hanging_sign": "Akacia elpendaĵo",
  "block.minecraft.acacia_leaves": "Akacia foliaro",
  "block.minecraft.acacia_log": "Akacia ŝtipo",
  "block.minecraft.acacia_planks": "Akacia tabularo",
  "block.minecraft.acacia_pressure_plate": "Akacia premplato",
  "block.minecraft.acacia_sapling": "Akaciido",
  "block.minecraft.acacia_shelf": "Akacia breto",
  "block.minecraft.acacia_sign": "Akacia ŝildeto",
  "block.minecraft.acacia_slab": "Akacia ŝtupo",
  "block.minecraft.acacia_stairs": "Akacia ŝtuparo",
  "block.minecraft.acacia_trapdoor": "Akacia klappordo",
  "block.minecraft.acacia_wall_hanging_sign": "Akacia surmura elpendaĵo",
  "block.minecraft.acacia_wall_sign": "Akacia surmura ŝildeto",
  "block.minecraft.acacia_wood": "Akacia ligno",
  "block.minecraft.activator_rail": "Aktivigila relo",
  "block.minecraft.air": "Aero",
  "block.minecraft.allium": "Aliumo",
  "block.minecraft.amethyst_block": "Ametista bloko",
  "block.minecraft.amethyst_cluster": "Amasiĝo da ametisto",
  "block.minecraft.ancient_debris": "Antikva rubo",
  "block.minecraft.andesite": "Andezito",
  "block.minecraft.andesite_slab": "Andezita ŝtupo",
  "block.minecraft.andesite_stairs": "Andezita ŝtuparo",
  "block.minecraft.andesite_wall": "Andezita muro",
  "block.minecraft.anvil": "Amboso",
  "block.minecraft.attached_melon_stem": "Alligita akvomelona tigo",
  "block.minecraft.attached_pumpkin_stem": "Alligita kukurba tigo",
  "block.minecraft.azalea": "Azaleo",
  "block.minecraft.azalea_leaves": "Azalea foliaro",
  "block.minecraft.azure_bluet": "Blua hustonio",
  "block.minecraft.bamboo": "Bambuo",
  "block.minecraft.bamboo_block": "Bambua bloko",
  "block.minecraft.bamboo_button": "Bambua prembutono",
  "block.minecraft.bamboo_door": "Bambua pordo",
  "block.minecraft.bamboo_fence": "Bambua barilo",
  "block.minecraft.bamboo_fence_gate": "Bambua barilpordo",
  "block.minecraft.bamboo_hanging_sign": "Bambua elpendaĵo",
  "block.minecraft.bamboo_mosaic": "Bambua mozaiko",
  "block.minecraft.bamboo_mosaic_slab": "Bambumozaika ŝtupo",
  "block.minecraft.bamboo_mosaic_stairs": "Bambumozaika ŝtuparo",
  "block.minecraft.bamboo_planks": "Bambua tabularo",
  "block.minecraft.bamboo_pressure_plate": "Bambua premplato",
  "block.minecraft.bamboo_sapling": "Bambuido",
  "block.minecraft.bamboo_shelf": "Bambua breto",
  "block.minecraft.bamboo_sign": "Bambua ŝildeto",
  "block.minecraft.bamboo_slab": "Bambua ŝtupo",
  "block.minecraft.bamboo_stairs": "Bambua ŝtuparo",
  "block.minecraft.bamboo_trapdoor": "Bambua klappordo",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambua surmura elpendaĵo",
  "block.minecraft.bamboo_wall_sign": "Bambua surmura ŝildeto",
  "block.minecraft.banner.base.black": "Plene nigra surfaco",
  "block.minecraft.banner.base.blue": "Plene blua surfaco",
  "block.minecraft.banner.base.brown": "Plene bruna surfaco",
  "block.minecraft.banner.base.cyan": "Plene turkisa surfaco",
  "block.minecraft.banner.base.gray": "Plene griza surfaco",
  "block.minecraft.banner.base.green": "Plene verda surfaco",
  "block.minecraft.banner.base.light_blue": "Plene helblua surfaco",
  "block.minecraft.banner.base.light_gray": "Plene helgriza surfaco",
  "block.minecraft.banner.base.lime": "Plene helverda surfaco",
  "block.minecraft.banner.base.magenta": "Plene malva surfaco",
  "block.minecraft.banner.base.orange": "Plene oranĝkolora surfaco",
  "block.minecraft.banner.base.pink": "Plene rozkolora surfaco",
  "block.minecraft.banner.base.purple": "Plene violkolora surfaco",
  "block.minecraft.banner.base.red": "Plene ruĝa surfaco",
  "block.minecraft.banner.base.white": "Plene blanka surfaco",
  "block.minecraft.banner.base.yellow": "Plene flava surfaco",
  "block.minecraft.banner.border.black": "Nigra bordero",
  "block.minecraft.banner.border.blue": "Blua bordero",
  "block.minecraft.banner.border.brown": "Bruna bordero",
  "block.minecraft.banner.border.cyan": "Turkisa bordero",
  "block.minecraft.banner.border.gray": "Griza bordero",
  "block.minecraft.banner.border.green": "Verda bordero",
  "block.minecraft.banner.border.light_blue": "Helblua bordero",
  "block.minecraft.banner.border.light_gray": "Helgriza bordero",
  "block.minecraft.banner.border.lime": "Helverda bordero",
  "block.minecraft.banner.border.magenta": "Malva bordero",
  "block.minecraft.banner.border.orange": "Oranĝkolora bordero",
  "block.minecraft.banner.border.pink": "Rozkolora bordero",
  "block.minecraft.banner.border.purple": "Violkolora bordero",
  "block.minecraft.banner.border.red": "Ruĝa bordero",
  "block.minecraft.banner.border.white": "Blanka bordero",
  "block.minecraft.banner.border.yellow": "Flava bordero",
  "block.minecraft.banner.bricks.black": "Nigre brikumita",
  "block.minecraft.banner.bricks.blue": "Blue brikumita",
  "block.minecraft.banner.bricks.brown": "Brune brikumita",
  "block.minecraft.banner.bricks.cyan": "Turkise brikumita",
  "block.minecraft.banner.bricks.gray": "Grize brikumita",
  "block.minecraft.banner.bricks.green": "Verde brikumita",
  "block.minecraft.banner.bricks.light_blue": "Helblue brikumita",
  "block.minecraft.banner.bricks.light_gray": "Helgrize brikumita",
  "block.minecraft.banner.bricks.lime": "Helverde brikumita",
  "block.minecraft.banner.bricks.magenta": "Malve brikumita",
  "block.minecraft.banner.bricks.orange": "Oranĝkolore brikumita",
  "block.minecraft.banner.bricks.pink": "Rozkolore brikumita",
  "block.minecraft.banner.bricks.purple": "Violkolore brikumita",
  "block.minecraft.banner.bricks.red": "Ruĝe brikumita",
  "block.minecraft.banner.bricks.white": "Blanke brikumita",
  "block.minecraft.banner.bricks.yellow": "Flave brikumita",
  "block.minecraft.banner.circle.black": "Nigra cirklo",
  "block.minecraft.banner.circle.blue": "Blua cirklo",
  "block.minecraft.banner.circle.brown": "Bruna cirklo",
  "block.minecraft.banner.circle.cyan": "Turkisa cirklo",
  "block.minecraft.banner.circle.gray": "Griza cirklo",
  "block.minecraft.banner.circle.green": "Verda cirklo",
  "block.minecraft.banner.circle.light_blue": "Helblua cirklo",
  "block.minecraft.banner.circle.light_gray": "Helgriza cirklo",
  "block.minecraft.banner.circle.lime": "Helverda cirklo",
  "block.minecraft.banner.circle.magenta": "Malva cirklo",
  "block.minecraft.banner.circle.orange": "Oranĝkolora cirklo",
  "block.minecraft.banner.circle.pink": "Rozkolora cirklo",
  "block.minecraft.banner.circle.purple": "Violkolora cirklo",
  "block.minecraft.banner.circle.red": "Ruĝa cirklo",
  "block.minecraft.banner.circle.white": "Blanka cirklo",
  "block.minecraft.banner.circle.yellow": "Flava cirklo",
  "block.minecraft.banner.creeper.black": "Nigra danĝero",
  "block.minecraft.banner.creeper.blue": "Blua danĝero",
  "block.minecraft.banner.creeper.brown": "Bruna danĝero",
  "block.minecraft.banner.creeper.cyan": "Turkisa danĝero",
  "block.minecraft.banner.creeper.gray": "Griza danĝero",
  "block.minecraft.banner.creeper.green": "Verda danĝero",
  "block.minecraft.banner.creeper.light_blue": "Helblua danĝero",
  "block.minecraft.banner.creeper.light_gray": "Helgriza danĝero",
  "block.minecraft.banner.creeper.lime": "Helverda danĝero",
  "block.minecraft.banner.creeper.magenta": "Malva danĝero",
  "block.minecraft.banner.creeper.orange": "Oranĝkolora danĝero",
  "block.minecraft.banner.creeper.pink": "Rozkolora danĝero",
  "block.minecraft.banner.creeper.purple": "Violkolora danĝero",
  "block.minecraft.banner.creeper.red": "Ruĝa danĝero",
  "block.minecraft.banner.creeper.white": "Blanka danĝero",
  "block.minecraft.banner.creeper.yellow": "Flava danĝero",
  "block.minecraft.banner.cross.black": "Nigra diagonala kruco",
  "block.minecraft.banner.cross.blue": "Blua diagonala kruco",
  "block.minecraft.banner.cross.brown": "Bruna diagonala kruco",
  "block.minecraft.banner.cross.cyan": "Turkisa diagonala kruco",
  "block.minecraft.banner.cross.gray": "Griza diagonala kruco",
  "block.minecraft.banner.cross.green": "Verda diagonala kruco",
  "block.minecraft.banner.cross.light_blue": "Helblua diagonala kruco",
  "block.minecraft.banner.cross.light_gray": "Helblua diagonala kruco",
  "block.minecraft.banner.cross.lime": "Helverda diagonala kruco",
  "block.minecraft.banner.cross.magenta": "Malva diagonala kruco",
  "block.minecraft.banner.cross.orange": "Oranĝkolora diagonala kruco",
  "block.minecraft.banner.cross.pink": "Rozkolora diagonala kruco",
  "block.minecraft.banner.cross.purple": "Violkolora diagonala kruco",
  "block.minecraft.banner.cross.red": "Ruĝa diagonala kruco",
  "block.minecraft.banner.cross.white": "Blanka diagonala kruco",
  "block.minecraft.banner.cross.yellow": "Flava diagonala kruco",
  "block.minecraft.banner.curly_border.black": "Nigre ondumita",
  "block.minecraft.banner.curly_border.blue": "Blue ondumita",
  "block.minecraft.banner.curly_border.brown": "Brune ondumita",
  "block.minecraft.banner.curly_border.cyan": "Turkise ondumita",
  "block.minecraft.banner.curly_border.gray": "Grize ondumita",
  "block.minecraft.banner.curly_border.green": "Verde ondumita",
  "block.minecraft.banner.curly_border.light_blue": "Helblue ondumita",
  "block.minecraft.banner.curly_border.light_gray": "Helgrize ondumita",
  "block.minecraft.banner.curly_border.lime": "Helverde ondumita",
  "block.minecraft.banner.curly_border.magenta": "Malve ondumita",
  "block.minecraft.banner.curly_border.orange": "Oranĝkolore ondumita",
  "block.minecraft.banner.curly_border.pink": "Rozkolore ondumita",
  "block.minecraft.banner.curly_border.purple": "Violkolore ondumita",
  "block.minecraft.banner.curly_border.red": "Ruĝe ondumita",
  "block.minecraft.banner.curly_border.white": "Blanke ondumita",
  "block.minecraft.banner.curly_border.yellow": "Flave ondumita",
  "block.minecraft.banner.diagonal_left.black": "Nigre hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.blue": "Blue hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.brown": "Brune hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.cyan": "Turkise hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.gray": "Grize hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.green": "Verde hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.light_blue": "Helblue hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.light_gray": "Helgrize hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.lime": "Helverde hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.magenta": "Malve hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.orange": "Oranĝkolore hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.pink": "Rozkolore hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.purple": "Violkolore hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.red": "Ruĝe hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.white": "Blanke hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_left.yellow": "Flave hakita supre-maldekstre",
  "block.minecraft.banner.diagonal_right.black": "Nigre hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.blue": "Blue hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.brown": "Brune hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.cyan": "Turkise hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.gray": "Grize hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.green": "Verde hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.light_blue": "Helblue hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.light_gray": "Helgrize hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.lime": "Helverde hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.magenta": "Malve hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.orange": "Oranĝkolore hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.pink": "Rozkolore hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.purple": "Violkolore hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.red": "Ruĝe hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.white": "Blanke hakita supre-dekstre",
  "block.minecraft.banner.diagonal_right.yellow": "Flave hakita supre-dekstre",
  "block.minecraft.banner.diagonal_up_left.black": "Nigre hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.brown": "Brune hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkise hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.gray": "Grize hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.green": "Verde hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Helblue hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Helgrize hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.lime": "Helverde hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.magenta": "Malve hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranĝkolore hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.pink": "Rozkolore hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.purple": "Violkolore hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.red": "Ruĝe hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.white": "Blanke hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_left.yellow": "Flave hakita malsupre-maldekstre",
  "block.minecraft.banner.diagonal_up_right.black": "Nigre hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.blue": "Blue hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.brown": "Brune hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkise hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.gray": "Grize hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.green": "Verde hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Helblue hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Helgrize hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.lime": "Helverde hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.magenta": "Malve hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranĝkolore hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.pink": "Rozkolore hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.purple": "Violkolore hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.red": "Ruĝe hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.white": "Blanke hakita malsupre-dekstre",
  "block.minecraft.banner.diagonal_up_right.yellow": "Flave hakita malsupre-dekstre",
  "block.minecraft.banner.flow.black": "Nigra kirlo",
  "block.minecraft.banner.flow.blue": "Blua kirlo",
  "block.minecraft.banner.flow.brown": "Bruna kirlo",
  "block.minecraft.banner.flow.cyan": "Turkisa kirlo",
  "block.minecraft.banner.flow.gray": "Griza kirlo",
  "block.minecraft.banner.flow.green": "Verda kirlo",
  "block.minecraft.banner.flow.light_blue": "Helblua kirlo",
  "block.minecraft.banner.flow.light_gray": "Helgriza kirlo",
  "block.minecraft.banner.flow.lime": "Helverda kirlo",
  "block.minecraft.banner.flow.magenta": "Malva kirlo",
  "block.minecraft.banner.flow.orange": "Oranĝkolora kirlo",
  "block.minecraft.banner.flow.pink": "Rozkolora kirlo",
  "block.minecraft.banner.flow.purple": "Violkolora kirlo",
  "block.minecraft.banner.flow.red": "Ruĝa kirlo",
  "block.minecraft.banner.flow.white": "Blanka kirlo",
  "block.minecraft.banner.flow.yellow": "Flava kirlo",
  "block.minecraft.banner.flower.black": "Nigra lilio",
  "block.minecraft.banner.flower.blue": "Blua lilio",
  "block.minecraft.banner.flower.brown": "Bruna lilio",
  "block.minecraft.banner.flower.cyan": "Turkisa lilio",
  "block.minecraft.banner.flower.gray": "Griza lilio",
  "block.minecraft.banner.flower.green": "Verda lilio",
  "block.minecraft.banner.flower.light_blue": "Helblua lilio",
  "block.minecraft.banner.flower.light_gray": "Helgriza lilio",
  "block.minecraft.banner.flower.lime": "Helverda lilio",
  "block.minecraft.banner.flower.magenta": "Malva lilio",
  "block.minecraft.banner.flower.orange": "Oranĝkolora lilio",
  "block.minecraft.banner.flower.pink": "Rozkolora lilio",
  "block.minecraft.banner.flower.purple": "Violkolora lilio",
  "block.minecraft.banner.flower.red": "Ruĝa lilio",
  "block.minecraft.banner.flower.white": "Blanka lilio",
  "block.minecraft.banner.flower.yellow": "Flava lilio",
  "block.minecraft.banner.globe.black": "Nigra terkubo",
  "block.minecraft.banner.globe.blue": "Blua terkubo",
  "block.minecraft.banner.globe.brown": "Bruna terkubo",
  "block.minecraft.banner.globe.cyan": "Turkisa terkubo",
  "block.minecraft.banner.globe.gray": "Griza terkubo",
  "block.minecraft.banner.globe.green": "Verda terkubo",
  "block.minecraft.banner.globe.light_blue": "Helblua terkubo",
  "block.minecraft.banner.globe.light_gray": "Helgriza terkubo",
  "block.minecraft.banner.globe.lime": "Helverda terkubo",
  "block.minecraft.banner.globe.magenta": "Malva terkubo",
  "block.minecraft.banner.globe.orange": "Oranĝkolora terkubo",
  "block.minecraft.banner.globe.pink": "Rozkolora terkubo",
  "block.minecraft.banner.globe.purple": "Violkolora terkubo",
  "block.minecraft.banner.globe.red": "Ruĝa terkubo",
  "block.minecraft.banner.globe.white": "Blanka terkubo",
  "block.minecraft.banner.globe.yellow": "Flava terkubo",
  "block.minecraft.banner.gradient.black": "Nigra supra gradiento",
  "block.minecraft.banner.gradient.blue": "Blua supra gradiento",
  "block.minecraft.banner.gradient.brown": "Bruna supra gradiento",
  "block.minecraft.banner.gradient.cyan": "Turkisa supra gradiento",
  "block.minecraft.banner.gradient.gray": "Griza supra gradiento",
  "block.minecraft.banner.gradient.green": "Verda supra gradiento",
  "block.minecraft.banner.gradient.light_blue": "Helblua supra gradiento",
  "block.minecraft.banner.gradient.light_gray": "Helgriza supra gradiento",
  "block.minecraft.banner.gradient.lime": "Helverda supra gradiento",
  "block.minecraft.banner.gradient.magenta": "Malva supra gradiento",
  "block.minecraft.banner.gradient.orange": "Oranĝkolora supra gradiento",
  "block.minecraft.banner.gradient.pink": "Rozkolora supra gradiento",
  "block.minecraft.banner.gradient.purple": "Violkolora supra gradiento",
  "block.minecraft.banner.gradient.red": "Ruĝa supra gradiento",
  "block.minecraft.banner.gradient.white": "Blanka supra gradiento",
  "block.minecraft.banner.gradient.yellow": "Flava supra gradiento",
  "block.minecraft.banner.gradient_up.black": "Nigra malsupra gradiento",
  "block.minecraft.banner.gradient_up.blue": "Blua malsupra gradiento",
  "block.minecraft.banner.gradient_up.brown": "Bruna malsupra gradiento",
  "block.minecraft.banner.gradient_up.cyan": "Turkisa malsupra gradiento",
  "block.minecraft.banner.gradient_up.gray": "Griza malsupra gradiento",
  "block.minecraft.banner.gradient_up.green": "Verda malsupra gradiento",
  "block.minecraft.banner.gradient_up.light_blue": "Helblua malsupra gradiento",
  "block.minecraft.banner.gradient_up.light_gray": "Helgriza malsupra gradiento",
  "block.minecraft.banner.gradient_up.lime": "Helverda malsupra gradiento",
  "block.minecraft.banner.gradient_up.magenta": "Malva malsupra gradiento",
  "block.minecraft.banner.gradient_up.orange": "Oranĝkolora malsupra gradiento",
  "block.minecraft.banner.gradient_up.pink": "Rozkolora malsupra gradiento",
  "block.minecraft.banner.gradient_up.purple": "Violkolora malsupra gradiento",
  "block.minecraft.banner.gradient_up.red": "Ruĝa malsupra gradiento",
  "block.minecraft.banner.gradient_up.white": "Blanka malsupra gradiento",
  "block.minecraft.banner.gradient_up.yellow": "Flava malsupra gradiento",
  "block.minecraft.banner.guster.black": "Nigra zumo",
  "block.minecraft.banner.guster.blue": "Blua zumo",
  "block.minecraft.banner.guster.brown": "Bruna zumo",
  "block.minecraft.banner.guster.cyan": "Turkisa zumo",
  "block.minecraft.banner.guster.gray": "Griza zumo",
  "block.minecraft.banner.guster.green": "Verda zumo",
  "block.minecraft.banner.guster.light_blue": "Helblua zumo",
  "block.minecraft.banner.guster.light_gray": "Helgriza zumo",
  "block.minecraft.banner.guster.lime": "Helverda zumo",
  "block.minecraft.banner.guster.magenta": "Malva zumo",
  "block.minecraft.banner.guster.orange": "Oranĝkolora zumo",
  "block.minecraft.banner.guster.pink": "Rozkolora zumo",
  "block.minecraft.banner.guster.purple": "Violkolora zumo",
  "block.minecraft.banner.guster.red": "Ruĝa zumo",
  "block.minecraft.banner.guster.white": "Blanka zumo",
  "block.minecraft.banner.guster.yellow": "Flava zumo",
  "block.minecraft.banner.half_horizontal.black": "Nigre tranĉita supre",
  "block.minecraft.banner.half_horizontal.blue": "Blue tranĉita supre",
  "block.minecraft.banner.half_horizontal.brown": "Brune tranĉita supre",
  "block.minecraft.banner.half_horizontal.cyan": "Turkise tranĉita supre",
  "block.minecraft.banner.half_horizontal.gray": "Grize tranĉita supre",
  "block.minecraft.banner.half_horizontal.green": "Verde tranĉita supre",
  "block.minecraft.banner.half_horizontal.light_blue": "Helblue tranĉita supre",
  "block.minecraft.banner.half_horizontal.light_gray": "Helgrize tranĉita supre",
  "block.minecraft.banner.half_horizontal.lime": "Helverde tranĉita supre",
  "block.minecraft.banner.half_horizontal.magenta": "Malve tranĉita supre",
  "block.minecraft.banner.half_horizontal.orange": "Oranĝkolore tranĉita supre",
  "block.minecraft.banner.half_horizontal.pink": "Rozkolore tranĉita supre",
  "block.minecraft.banner.half_horizontal.purple": "Violkolore tranĉita supre",
  "block.minecraft.banner.half_horizontal.red": "Ruĝe tranĉita supre",
  "block.minecraft.banner.half_horizontal.white": "Blanke tranĉita supre",
  "block.minecraft.banner.half_horizontal.yellow": "Flave tranĉita supre",
  "block.minecraft.banner.half_horizontal_bottom.black": "Nigre tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blue tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brune tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkise tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grize tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.green": "Verde tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Helblue tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Helgrize tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Helverde tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Malve tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranĝkolore tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rozkolore tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Violkolore tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.red": "Ruĝe tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.white": "Blanke tranĉita malsupre",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Flave tranĉita malsupre",
  "block.minecraft.banner.half_vertical.black": "Nigre fendita maldekstre",
  "block.minecraft.banner.half_vertical.blue": "Blue fendita maldekstre",
  "block.minecraft.banner.half_vertical.brown": "Brune fendita maldekstre",
  "block.minecraft.banner.half_vertical.cyan": "Turkise fendita maldekstre",
  "block.minecraft.banner.half_vertical.gray": "Grize fendita maldekstre",
  "block.minecraft.banner.half_vertical.green": "Verde fendita maldekstre",
  "block.minecraft.banner.half_vertical.light_blue": "Helblue fendita maldekstre",
  "block.minecraft.banner.half_vertical.light_gray": "Helgrize fendita maldekstre",
  "block.minecraft.banner.half_vertical.lime": "Helverde fendita maldekstre",
  "block.minecraft.banner.half_vertical.magenta": "Malve fendita maldekstre",
  "block.minecraft.banner.half_vertical.orange": "Oranĝkolore fendita maldekstre",
  "block.minecraft.banner.half_vertical.pink": "Rozkolore fendita maldekstre",
  "block.minecraft.banner.half_vertical.purple": "Violkolore fendita maldekstre",
  "block.minecraft.banner.half_vertical.red": "Ruĝe fendita maldekstre",
  "block.minecraft.banner.half_vertical.white": "Blanke fendita maldekstre",
  "block.minecraft.banner.half_vertical.yellow": "Flave fendita maldekstre",
  "block.minecraft.banner.half_vertical_right.black": "Nigre fendita dekstre",
  "block.minecraft.banner.half_vertical_right.blue": "Blue fendita dekstre",
  "block.minecraft.banner.half_vertical_right.brown": "Brune fendita dekstre",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkise fendita dekstre",
  "block.minecraft.banner.half_vertical_right.gray": "Grize fendita dekstre",
  "block.minecraft.banner.half_vertical_right.green": "Verde fendita dekstre",
  "block.minecraft.banner.half_vertical_right.light_blue": "Helblue fendita dekstre",
  "block.minecraft.banner.half_vertical_right.light_gray": "Helgrize fendita dekstre",
  "block.minecraft.banner.half_vertical_right.lime": "Helverde fendita dekstre",
  "block.minecraft.banner.half_vertical_right.magenta": "Malve fendita dekstre",
  "block.minecraft.banner.half_vertical_right.orange": "Oranĝkolore fendita dekstre",
  "block.minecraft.banner.half_vertical_right.pink": "Rozkolore fendita dekstre",
  "block.minecraft.banner.half_vertical_right.purple": "Violkolore fendita dekstre",
  "block.minecraft.banner.half_vertical_right.red": "Ruĝe fendita dekstre",
  "block.minecraft.banner.half_vertical_right.white": "Blanke fendita dekstre",
  "block.minecraft.banner.half_vertical_right.yellow": "Flave fendita dekstre",
  "block.minecraft.banner.mojang.black": "Nigra umo",
  "block.minecraft.banner.mojang.blue": "Blua umo",
  "block.minecraft.banner.mojang.brown": "Bruna umo",
  "block.minecraft.banner.mojang.cyan": "Turkisa umo",
  "block.minecraft.banner.mojang.gray": "Griza umo",
  "block.minecraft.banner.mojang.green": "Verda umo",
  "block.minecraft.banner.mojang.light_blue": "Helblua umo",
  "block.minecraft.banner.mojang.light_gray": "Helgriza umo",
  "block.minecraft.banner.mojang.lime": "Limea umo",
  "block.minecraft.banner.mojang.magenta": "Malva umo",
  "block.minecraft.banner.mojang.orange": "Oranĝkolora umo",
  "block.minecraft.banner.mojang.pink": "Rozkolora umo",
  "block.minecraft.banner.mojang.purple": "Violkolora umo",
  "block.minecraft.banner.mojang.red": "Ruĝa umo",
  "block.minecraft.banner.mojang.white": "Blanka umo",
  "block.minecraft.banner.mojang.yellow": "Flava umo",
  "block.minecraft.banner.piglin.black": "Nigra rostro",
  "block.minecraft.banner.piglin.blue": "Blua rostro",
  "block.minecraft.banner.piglin.brown": "Bruna rostro",
  "block.minecraft.banner.piglin.cyan": "Turkisa rostro",
  "block.minecraft.banner.piglin.gray": "Griza rostro",
  "block.minecraft.banner.piglin.green": "Verda rostro",
  "block.minecraft.banner.piglin.light_blue": "Helblua rostro",
  "block.minecraft.banner.piglin.light_gray": "Helgriza rostro",
  "block.minecraft.banner.piglin.lime": "Helverda rostro",
  "block.minecraft.banner.piglin.magenta": "Malva rostro",
  "block.minecraft.banner.piglin.orange": "Oranĝkolora rostro",
  "block.minecraft.banner.piglin.pink": "Rozkolora rostro",
  "block.minecraft.banner.piglin.purple": "Violkolora rostro",
  "block.minecraft.banner.piglin.red": "Ruĝa rostro",
  "block.minecraft.banner.piglin.white": "Blanka rostro",
  "block.minecraft.banner.piglin.yellow": "Flava rostro",
  "block.minecraft.banner.rhombus.black": "Nigra lozanĝo",
  "block.minecraft.banner.rhombus.blue": "Blua lozanĝo",
  "block.minecraft.banner.rhombus.brown": "Bruna lozanĝo",
  "block.minecraft.banner.rhombus.cyan": "Turkisa lozanĝo",
  "block.minecraft.banner.rhombus.gray": "Griza lozanĝo",
  "block.minecraft.banner.rhombus.green": "Verda lozanĝo",
  "block.minecraft.banner.rhombus.light_blue": "Helblua lozanĝo",
  "block.minecraft.banner.rhombus.light_gray": "Helgriza lozanĝo",
  "block.minecraft.banner.rhombus.lime": "Helverda lozanĝo",
  "block.minecraft.banner.rhombus.magenta": "Malva lozanĝo",
  "block.minecraft.banner.rhombus.orange": "Oranĝkolora lozanĝo",
  "block.minecraft.banner.rhombus.pink": "Rozkolora lozanĝo",
  "block.minecraft.banner.rhombus.purple": "Violkolora lozanĝo",
  "block.minecraft.banner.rhombus.red": "Ruĝa lozanĝo",
  "block.minecraft.banner.rhombus.white": "Blanka lozanĝo",
  "block.minecraft.banner.rhombus.yellow": "Flava lozanĝo",
  "block.minecraft.banner.skull.black": "Nigra kranio",
  "block.minecraft.banner.skull.blue": "Blua kranio",
  "block.minecraft.banner.skull.brown": "Bruna kranio",
  "block.minecraft.banner.skull.cyan": "Turkisa kranio",
  "block.minecraft.banner.skull.gray": "Griza kranio",
  "block.minecraft.banner.skull.green": "Verda kranio",
  "block.minecraft.banner.skull.light_blue": "Helblua kranio",
  "block.minecraft.banner.skull.light_gray": "Helgriza kranio",
  "block.minecraft.banner.skull.lime": "Helverda kranio",
  "block.minecraft.banner.skull.magenta": "Malva kranio",
  "block.minecraft.banner.skull.orange": "Oranĝkolora kranio",
  "block.minecraft.banner.skull.pink": "Rozkolora kranio",
  "block.minecraft.banner.skull.purple": "Violkolora kranio",
  "block.minecraft.banner.skull.red": "Ruĝa kranio",
  "block.minecraft.banner.skull.white": "Blanka kranio",
  "block.minecraft.banner.skull.yellow": "Flava kranio",
  "block.minecraft.banner.small_stripes.black": "Nigre palisumita",
  "block.minecraft.banner.small_stripes.blue": "Blue palisumita",
  "block.minecraft.banner.small_stripes.brown": "Brune palisumita",
  "block.minecraft.banner.small_stripes.cyan": "Turkise palisumita",
  "block.minecraft.banner.small_stripes.gray": "Grize palisumita",
  "block.minecraft.banner.small_stripes.green": "Verde palisumita",
  "block.minecraft.banner.small_stripes.light_blue": "Helblue palisumita",
  "block.minecraft.banner.small_stripes.light_gray": "Helgrize palisumita",
  "block.minecraft.banner.small_stripes.lime": "Helverde palisumita",
  "block.minecraft.banner.small_stripes.magenta": "Malve palisumita",
  "block.minecraft.banner.small_stripes.orange": "Oranĝkolore palisumita",
  "block.minecraft.banner.small_stripes.pink": "Rozkolore palisumita",
  "block.minecraft.banner.small_stripes.purple": "Violkolore palisumita",
  "block.minecraft.banner.small_stripes.red": "Ruĝe palisumita",
  "block.minecraft.banner.small_stripes.white": "Blanke palisumita",
  "block.minecraft.banner.small_stripes.yellow": "Flave palisumita",
  "block.minecraft.banner.square_bottom_left.black": "Nigra malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.blue": "Blua malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.brown": "Bruna malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkisa malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.gray": "Griza malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.green": "Verda malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.light_blue": "Helblua malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.light_gray": "Helgriza malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.lime": "Helverda malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.magenta": "Malva malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.orange": "Oranĝkolora malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.pink": "Rozkolora malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.purple": "Violkolora malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_left.red": "Ruĝa malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.white": "Blanka malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_left.yellow": "Flava malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_right.black": "Nigra malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.blue": "Blua malsupra maldekstra kantono",
  "block.minecraft.banner.square_bottom_right.brown": "Bruna malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkisa malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.gray": "Griza malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.green": "Verda malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.light_blue": "Helblua malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.light_gray": "Helgriza malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.lime": "Helverda malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.magenta": "Malva malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.orange": "Oranĝkolora malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.pink": "Rozkolora malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.purple": "Violkolora malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.red": "Ruĝa malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.white": "Blanka malsupra dekstra kantono",
  "block.minecraft.banner.square_bottom_right.yellow": "Flava malsupra dekstra kantono",
  "block.minecraft.banner.square_top_left.black": "Nigra supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.blue": "Blua supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.brown": "Bruna supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.cyan": "Turkisa supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.gray": "Griza supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.green": "Verda supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.light_blue": "Helblua supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.light_gray": "Helgriza supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.lime": "Helverda supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.magenta": "Malva supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.orange": "Oranĝkolora supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.pink": "Rozkolora supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.purple": "Violkolora supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.red": "Ruĝa supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.white": "Blanka supra maldekstra kantono",
  "block.minecraft.banner.square_top_left.yellow": "Flava supra maldekstra kantono",
  "block.minecraft.banner.square_top_right.black": "Nigra supra dekstra kantono",
  "block.minecraft.banner.square_top_right.blue": "Blua supra dekstra kantono",
  "block.minecraft.banner.square_top_right.brown": "Bruna supra dekstra kantono",
  "block.minecraft.banner.square_top_right.cyan": "Turkisa supra dekstra kantono",
  "block.minecraft.banner.square_top_right.gray": "Griza supra dekstra kantono",
  "block.minecraft.banner.square_top_right.green": "Verda supra dekstra kantono",
  "block.minecraft.banner.square_top_right.light_blue": "Helblua supra dekstra kantono",
  "block.minecraft.banner.square_top_right.light_gray": "Helgriza supra dekstra kantono",
  "block.minecraft.banner.square_top_right.lime": "Helverda supra dekstra kantono",
  "block.minecraft.banner.square_top_right.magenta": "Malva supra dekstra kantono",
  "block.minecraft.banner.square_top_right.orange": "Oranĝkolora supra dekstra kantono",
  "block.minecraft.banner.square_top_right.pink": "Rozkolora supra dekstra kantono",
  "block.minecraft.banner.square_top_right.purple": "Violkolora supra dekstra kantono",
  "block.minecraft.banner.square_top_right.red": "Ruĝa supra dekstra kantono",
  "block.minecraft.banner.square_top_right.white": "Blanka supra dekstra kantono",
  "block.minecraft.banner.square_top_right.yellow": "Flava supra dekstra kantono",
  "block.minecraft.banner.straight_cross.black": "Nigra rekta kruco",
  "block.minecraft.banner.straight_cross.blue": "Blua rekta kruco",
  "block.minecraft.banner.straight_cross.brown": "Bruna rekta kruco",
  "block.minecraft.banner.straight_cross.cyan": "Turkisa rekta kruco",
  "block.minecraft.banner.straight_cross.gray": "Griza rekta kruco",
  "block.minecraft.banner.straight_cross.green": "Verda rekta kruco",
  "block.minecraft.banner.straight_cross.light_blue": "Helblua rekta kruco",
  "block.minecraft.banner.straight_cross.light_gray": "Helgriza rekta kruco",
  "block.minecraft.banner.straight_cross.lime": "Helverda rekta kruco",
  "block.minecraft.banner.straight_cross.magenta": "Malva rekta kruco",
  "block.minecraft.banner.straight_cross.orange": "Oranĝkolora rekta kruco",
  "block.minecraft.banner.straight_cross.pink": "Rozkolora rekta kruco",
  "block.minecraft.banner.straight_cross.purple": "Violkolora rekta kruco",
  "block.minecraft.banner.straight_cross.red": "Ruĝa rekta kruco",
  "block.minecraft.banner.straight_cross.white": "Blanka rekta kruco",
  "block.minecraft.banner.straight_cross.yellow": "Flava rekta kruco",
  "block.minecraft.banner.stripe_bottom.black": "Nigra ŝildobazo",
  "block.minecraft.banner.stripe_bottom.blue": "Blua ŝildobazo",
  "block.minecraft.banner.stripe_bottom.brown": "Bruna ŝildobazo",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkisa ŝildobazo",
  "block.minecraft.banner.stripe_bottom.gray": "Griza ŝildobazo",
  "block.minecraft.banner.stripe_bottom.green": "Verda ŝildobazo",
  "block.minecraft.banner.stripe_bottom.light_blue": "Helblua ŝildobazo",
  "block.minecraft.banner.stripe_bottom.light_gray": "Helgriza ŝildobazo",
  "block.minecraft.banner.stripe_bottom.lime": "Helverda ŝildobazo",
  "block.minecraft.banner.stripe_bottom.magenta": "Malva ŝildobazo",
  "block.minecraft.banner.stripe_bottom.orange": "Oranĝkolora ŝildobazo",
  "block.minecraft.banner.stripe_bottom.pink": "Rozkolora ŝildobazo",
  "block.minecraft.banner.stripe_bottom.purple": "Violkolora ŝildobazo",
  "block.minecraft.banner.stripe_bottom.red": "Ruĝa ŝildobazo",
  "block.minecraft.banner.stripe_bottom.white": "Blanka ŝildobazo",
  "block.minecraft.banner.stripe_bottom.yellow": "Flava ŝildobazo",
  "block.minecraft.banner.stripe_center.black": "Nigra paliso",
  "block.minecraft.banner.stripe_center.blue": "Blua paliso",
  "block.minecraft.banner.stripe_center.brown": "Bruna paliso",
  "block.minecraft.banner.stripe_center.cyan": "Turkisa paliso",
  "block.minecraft.banner.stripe_center.gray": "Griza paliso",
  "block.minecraft.banner.stripe_center.green": "Verda paliso",
  "block.minecraft.banner.stripe_center.light_blue": "Helblua paliso",
  "block.minecraft.banner.stripe_center.light_gray": "Helgriza paliso",
  "block.minecraft.banner.stripe_center.lime": "Helverda paliso",
  "block.minecraft.banner.stripe_center.magenta": "Malva paliso",
  "block.minecraft.banner.stripe_center.orange": "Oranĝkolora paliso",
  "block.minecraft.banner.stripe_center.pink": "Rozkolora paliso",
  "block.minecraft.banner.stripe_center.purple": "Violkolora paliso",
  "block.minecraft.banner.stripe_center.red": "Ruĝa paliso",
  "block.minecraft.banner.stripe_center.white": "Blanka paliso",
  "block.minecraft.banner.stripe_center.yellow": "Flava paliso",
  "block.minecraft.banner.stripe_downleft.black": "Nigra maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.blue": "Blua maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.brown": "Bruna maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkisa maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.gray": "Griza maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.green": "Verda maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.light_blue": "Helblua maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.light_gray": "Helgriza maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.lime": "Helverda maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.magenta": "Malva maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.orange": "Oranĝkolora maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.pink": "Rozkolora maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.purple": "Violkolora maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.red": "Ruĝa maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.white": "Blanka maldekstra bendo",
  "block.minecraft.banner.stripe_downleft.yellow": "Flava maldekstra bendo",
  "block.minecraft.banner.stripe_downright.black": "Nigra dekstra bendo",
  "block.minecraft.banner.stripe_downright.blue": "Blua dekstra bendo",
  "block.minecraft.banner.stripe_downright.brown": "Bruna dekstra bendo",
  "block.minecraft.banner.stripe_downright.cyan": "Turkisa dekstra bendo",
  "block.minecraft.banner.stripe_downright.gray": "Griza dekstra bendo",
  "block.minecraft.banner.stripe_downright.green": "Verda dekstra bendo",
  "block.minecraft.banner.stripe_downright.light_blue": "Helblua dekstra bendo",
  "block.minecraft.banner.stripe_downright.light_gray": "Helgriza dekstra bendo",
  "block.minecraft.banner.stripe_downright.lime": "Helverda dekstra bendo",
  "block.minecraft.banner.stripe_downright.magenta": "Malva dekstra bendo",
  "block.minecraft.banner.stripe_downright.orange": "Oranĝkolora dekstra bendo",
  "block.minecraft.banner.stripe_downright.pink": "Rozkolora dekstra bendo",
  "block.minecraft.banner.stripe_downright.purple": "Violkolora dekstra bendo",
  "block.minecraft.banner.stripe_downright.red": "Ruĝa dekstra bendo",
  "block.minecraft.banner.stripe_downright.white": "Blanka dekstra bendo",
  "block.minecraft.banner.stripe_downright.yellow": "Flava dekstra bendo",
  "block.minecraft.banner.stripe_left.black": "Nigra maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.blue": "Blua maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.brown": "Bruna maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.cyan": "Turkisa maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.gray": "Griza maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.green": "Verda maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.light_blue": "Helblua maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.light_gray": "Helgriza maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.lime": "Helverda maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.magenta": "Malva maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.orange": "Oranĝkolora maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.pink": "Rozkolora maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.purple": "Violkolora maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.red": "Ruĝa maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.white": "Blanka maldekstra flankaĵo",
  "block.minecraft.banner.stripe_left.yellow": "Flava maldekstra flankaĵo",
  "block.minecraft.banner.stripe_middle.black": "Nigra trabo",
  "block.minecraft.banner.stripe_middle.blue": "Blua trabo",
  "block.minecraft.banner.stripe_middle.brown": "Bruna trabo",
  "block.minecraft.banner.stripe_middle.cyan": "Turkisa trabo",
  "block.minecraft.banner.stripe_middle.gray": "Griza trabo",
  "block.minecraft.banner.stripe_middle.green": "Verda trabo",
  "block.minecraft.banner.stripe_middle.light_blue": "Helblua trabo",
  "block.minecraft.banner.stripe_middle.light_gray": "Helgriza trabo",
  "block.minecraft.banner.stripe_middle.lime": "Helverda trabo",
  "block.minecraft.banner.stripe_middle.magenta": "Malva trabo",
  "block.minecraft.banner.stripe_middle.orange": "Oranĝa trabo",
  "block.minecraft.banner.stripe_middle.pink": "Rozkolora trabo",
  "block.minecraft.banner.stripe_middle.purple": "Violkolora trabo",
  "block.minecraft.banner.stripe_middle.red": "Ruĝa trabo",
  "block.minecraft.banner.stripe_middle.white": "Blanka trabo",
  "block.minecraft.banner.stripe_middle.yellow": "Flava trabo",
  "block.minecraft.banner.stripe_right.black": "Nigra dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.blue": "Blua dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.brown": "Bruna dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.cyan": "Turkisa dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.gray": "Griza dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.green": "Verda dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.light_blue": "Helblua dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.light_gray": "Helgriza dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.lime": "Helverda dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.magenta": "Malva dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.orange": "Oranĝkolora dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.pink": "Rozkolora dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.purple": "Violkolora dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.red": "Ruĝa dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.white": "Blanka dekstra flankaĵo",
  "block.minecraft.banner.stripe_right.yellow": "Flava dekstra flankaĵo",
  "block.minecraft.banner.stripe_top.black": "Nigra ŝildokapo",
  "block.minecraft.banner.stripe_top.blue": "Blua ŝildokapo",
  "block.minecraft.banner.stripe_top.brown": "Bruna ŝildokapo",
  "block.minecraft.banner.stripe_top.cyan": "Turkisa ŝildokapo",
  "block.minecraft.banner.stripe_top.gray": "Griza ŝildokapo",
  "block.minecraft.banner.stripe_top.green": "Verda ŝildokapo",
  "block.minecraft.banner.stripe_top.light_blue": "Helblua ŝildokapo",
  "block.minecraft.banner.stripe_top.light_gray": "Helgriza ŝildokapo",
  "block.minecraft.banner.stripe_top.lime": "Helverda ŝildokapo",
  "block.minecraft.banner.stripe_top.magenta": "Malva ŝildokapo",
  "block.minecraft.banner.stripe_top.orange": "Oranĝkolora ŝildokapo",
  "block.minecraft.banner.stripe_top.pink": "Rozkolora ŝildokapo",
  "block.minecraft.banner.stripe_top.purple": "Violkolora ŝildokapo",
  "block.minecraft.banner.stripe_top.red": "Ruĝa ŝildokapo",
  "block.minecraft.banner.stripe_top.white": "Blanka ŝildokapo",
  "block.minecraft.banner.stripe_top.yellow": "Flava ŝildokapo",
  "block.minecraft.banner.triangle_bottom.black": "Nigra supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.blue": "Blua supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.brown": "Bruna supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkisa supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.gray": "Griza supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.green": "Verda supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.light_blue": "Helblua supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.light_gray": "Helgriza supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.lime": "Helverda supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.magenta": "Malva supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.orange": "Oranĝkolora supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.pink": "Rozkolora supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.purple": "Violkolora supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.red": "Ruĝa supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.white": "Blanka supra ĉevrono",
  "block.minecraft.banner.triangle_bottom.yellow": "Flava supra ĉevrono",
  "block.minecraft.banner.triangle_top.black": "Nigra malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.blue": "Blua malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.brown": "Bruna malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.cyan": "Turkisa malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.gray": "Griza malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.green": "Verda malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.light_blue": "Helblua malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.light_gray": "Helgriza malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.lime": "Helverda malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.magenta": "Malva malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.orange": "Oranĝkolora malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.pink": "Rozkolora malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.purple": "Violkolora malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.red": "Ruĝa malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.white": "Blanka malsupra ĉevrono",
  "block.minecraft.banner.triangle_top.yellow": "Flava malsupra ĉevrono",
  "block.minecraft.banner.triangles_bottom.black": "Nigre dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.blue": "Blue dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.brown": "Brune dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkise dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.gray": "Grize dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.green": "Verde dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.light_blue": "Helblue dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.light_gray": "Helgrize dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.lime": "Helverde dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.magenta": "Malve dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.orange": "Oranĝkolore dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.pink": "Rozkolore dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.purple": "Violkolore dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.red": "Ruĝe dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.white": "Blanke dentumita malsupre",
  "block.minecraft.banner.triangles_bottom.yellow": "Flave dentumita malsupre",
  "block.minecraft.banner.triangles_top.black": "Nigre dentumita supre",
  "block.minecraft.banner.triangles_top.blue": "Blue dentumita supre",
  "block.minecraft.banner.triangles_top.brown": "Brune dentumita supre",
  "block.minecraft.banner.triangles_top.cyan": "Turkise dentumita supre",
  "block.minecraft.banner.triangles_top.gray": "Grize dentumita supre",
  "block.minecraft.banner.triangles_top.green": "Verde dentumita supre",
  "block.minecraft.banner.triangles_top.light_blue": "Helblue dentumita supre",
  "block.minecraft.banner.triangles_top.light_gray": "Helgrize dentumita supre",
  "block.minecraft.banner.triangles_top.lime": "Helverde dentumita supre",
  "block.minecraft.banner.triangles_top.magenta": "Malve dentumita supre",
  "block.minecraft.banner.triangles_top.orange": "Oranĝkolore dentumita supre",
  "block.minecraft.banner.triangles_top.pink": "Rozkolore dentumita supre",
  "block.minecraft.banner.triangles_top.purple": "Violkolore dentumita supre",
  "block.minecraft.banner.triangles_top.red": "Ruĝe dentumita supre",
  "block.minecraft.banner.triangles_top.white": "Blanke dentumita supre",
  "block.minecraft.banner.triangles_top.yellow": "Flave dentumita supre",
  "block.minecraft.barrel": "Barelo",
  "block.minecraft.barrier": "Barilego",
  "block.minecraft.basalt": "Bazalto",
  "block.minecraft.beacon": "Lumstriilo",
  "block.minecraft.beacon.primary": "Unua efiko",
  "block.minecraft.beacon.secondary": "Dua efiko",
  "block.minecraft.bed.no_sleep": "Oni povas dormi nur nokte aŭ dum fulmotondro",
  "block.minecraft.bed.not_safe": "Oni ne povas ekdormi apud monstroj",
  "block.minecraft.bed.obstructed": "Ĉi tiu lito estas obstrukcita",
  "block.minecraft.bed.occupied": "Ĉi tiu lito estas uzata",
  "block.minecraft.bed.too_far_away": "Oni ne povas enlitiĝi de tiel malproksime",
  "block.minecraft.bedrock": "Bazroko",
  "block.minecraft.bee_nest": "Abelnesto",
  "block.minecraft.beehive": "Abelujo",
  "block.minecraft.beetroots": "Ruĝbetoj",
  "block.minecraft.bell": "Sonorilo",
  "block.minecraft.big_dripleaf": "Gutfoliego",
  "block.minecraft.big_dripleaf_stem": "Gutfoliega tigo",
  "block.minecraft.birch_button": "Betula prembutono",
  "block.minecraft.birch_door": "Betula pordo",
  "block.minecraft.birch_fence": "Betula barilo",
  "block.minecraft.birch_fence_gate": "Betula barilpordo",
  "block.minecraft.birch_hanging_sign": "Betula elpendaĵo",
  "block.minecraft.birch_leaves": "Betula foliaro",
  "block.minecraft.birch_log": "Betula ŝtipo",
  "block.minecraft.birch_planks": "Betula tabularo",
  "block.minecraft.birch_pressure_plate": "Betula premplato",
  "block.minecraft.birch_sapling": "Betulido",
  "block.minecraft.birch_shelf": "Betula breto",
  "block.minecraft.birch_sign": "Betula ŝildeto",
  "block.minecraft.birch_slab": "Betula ŝtupo",
  "block.minecraft.birch_stairs": "Betula ŝtuparo",
  "block.minecraft.birch_trapdoor": "Betula klappordo",
  "block.minecraft.birch_wall_hanging_sign": "Betula surmura elpendaĵo",
  "block.minecraft.birch_wall_sign": "Betula surmura ŝildeto",
  "block.minecraft.birch_wood": "Betula ligno",
  "block.minecraft.black_banner": "Nigra standardo",
  "block.minecraft.black_bed": "Nigra lito",
  "block.minecraft.black_candle": "Nigra kandelo",
  "block.minecraft.black_candle_cake": "Torto kun nigra kandelo",
  "block.minecraft.black_carpet": "Nigra tapiŝo",
  "block.minecraft.black_concrete": "Nigra betono",
  "block.minecraft.black_concrete_powder": "Nigra cemento",
  "block.minecraft.black_glazed_terracotta": "Nigra glazurita terakoto",
  "block.minecraft.black_shulker_box": "Nigra Shulkerskatolo",
  "block.minecraft.black_stained_glass": "Nigrigita vitro",
  "block.minecraft.black_stained_glass_pane": "Nigrigita glaco",
  "block.minecraft.black_terracotta": "Nigra terakoto",
  "block.minecraft.black_wool": "Nigra lano",
  "block.minecraft.blackstone": "Nigroŝtono",
  "block.minecraft.blackstone_slab": "Nigroŝtona ŝtupo",
  "block.minecraft.blackstone_stairs": "Nigroŝtona ŝtuparo",
  "block.minecraft.blackstone_wall": "Nigroŝtona muro",
  "block.minecraft.blast_furnace": "Altforno",
  "block.minecraft.blue_banner": "Blua standardo",
  "block.minecraft.blue_bed": "Blua lito",
  "block.minecraft.blue_candle": "Blua kandelo",
  "block.minecraft.blue_candle_cake": "Torto kun blua kandelo",
  "block.minecraft.blue_carpet": "Blua tapiŝo",
  "block.minecraft.blue_concrete": "Blua betono",
  "block.minecraft.blue_concrete_powder": "Blua cemento",
  "block.minecraft.blue_glazed_terracotta": "Blua glazurita terakoto",
  "block.minecraft.blue_ice": "Glacio blua",
  "block.minecraft.blue_orchid": "Blua orkido",
  "block.minecraft.blue_shulker_box": "Blua Shulkerskatolo",
  "block.minecraft.blue_stained_glass": "Bluigita vitro",
  "block.minecraft.blue_stained_glass_pane": "Bluigita glaco",
  "block.minecraft.blue_terracotta": "Blua terakoto",
  "block.minecraft.blue_wool": "Blua lano",
  "block.minecraft.bone_block": "Osta bloko",
  "block.minecraft.bookshelf": "Librobretaro",
  "block.minecraft.brain_coral": "Cerbokoralo",
  "block.minecraft.brain_coral_block": "Bloko cerbokorala",
  "block.minecraft.brain_coral_fan": "Ventumilo cerbokorala",
  "block.minecraft.brain_coral_wall_fan": "Surmura ventumilo cerbokorala",
  "block.minecraft.brewing_stand": "Eliksirfarilo",
  "block.minecraft.brick_slab": "Brika ŝtupo",
  "block.minecraft.brick_stairs": "Brika ŝtuparo",
  "block.minecraft.brick_wall": "Brika muro",
  "block.minecraft.bricks": "Brikaro",
  "block.minecraft.brown_banner": "Bruna standardo",
  "block.minecraft.brown_bed": "Bruna lito",
  "block.minecraft.brown_candle": "Bruna kandelo",
  "block.minecraft.brown_candle_cake": "Torto kun bruna kandelo",
  "block.minecraft.brown_carpet": "Bruna tapiŝo",
  "block.minecraft.brown_concrete": "Bruna betono",
  "block.minecraft.brown_concrete_powder": "Bruna cemento",
  "block.minecraft.brown_glazed_terracotta": "Bruna glazurita terakoto",
  "block.minecraft.brown_mushroom": "Boleto",
  "block.minecraft.brown_mushroom_block": "Boleta bloko",
  "block.minecraft.brown_shulker_box": "Bruna Shulkerskatolo",
  "block.minecraft.brown_stained_glass": "Brunigita vitro",
  "block.minecraft.brown_stained_glass_pane": "Brunigita glaco",
  "block.minecraft.brown_terracotta": "Bruna terakoto",
  "block.minecraft.brown_wool": "Bruna lano",
  "block.minecraft.bubble_column": "Bobela kolumno",
  "block.minecraft.bubble_coral": "Bobelokoralo",
  "block.minecraft.bubble_coral_block": "Bloko bobelokorala",
  "block.minecraft.bubble_coral_fan": "Ventumilo bobelokorala",
  "block.minecraft.bubble_coral_wall_fan": "Surmura ventumilo bobelokorala",
  "block.minecraft.budding_amethyst": "Burĝonanta ametisto",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Kakto",
  "block.minecraft.cactus_flower": "Kakta floro",
  "block.minecraft.cake": "Torto",
  "block.minecraft.calcite": "Kalcito",
  "block.minecraft.calibrated_sculk_sensor": "Agordebla Sculka sensoro",
  "block.minecraft.campfire": "Tendarfajro",
  "block.minecraft.candle": "Kandelo",
  "block.minecraft.candle_cake": "Torto kun kandelo",
  "block.minecraft.carrots": "Karotoj",
  "block.minecraft.cartography_table": "Kartografitablo",
  "block.minecraft.carved_pumpkin": "Tajlita kukurbo",
  "block.minecraft.cauldron": "Kaldrono",
  "block.minecraft.cave_air": "Kaverna aero",
  "block.minecraft.cave_vines": "Kaverna hedero",
  "block.minecraft.cave_vines_plant": "Planto de kaverna hedero",
  "block.minecraft.chain": "Ĉeno",
  "block.minecraft.chain_command_block": "Ĉena komanda bloko",
  "block.minecraft.cherry_button": "Sakura prembutono",
  "block.minecraft.cherry_door": "Sakura pordo",
  "block.minecraft.cherry_fence": "Sakura barilo",
  "block.minecraft.cherry_fence_gate": "Sakura barilpordo",
  "block.minecraft.cherry_hanging_sign": "Sakura elpendaĵo",
  "block.minecraft.cherry_leaves": "Sakura foliaro",
  "block.minecraft.cherry_log": "Sakura ŝtipo",
  "block.minecraft.cherry_planks": "Sakura tabularo",
  "block.minecraft.cherry_pressure_plate": "Sakura premplato",
  "block.minecraft.cherry_sapling": "Sakurido",
  "block.minecraft.cherry_shelf": "Sakura breto",
  "block.minecraft.cherry_sign": "Sakura ŝildeto",
  "block.minecraft.cherry_slab": "Sakura ŝtupo",
  "block.minecraft.cherry_stairs": "Sakura ŝtuparo",
  "block.minecraft.cherry_trapdoor": "Sakura klappordo",
  "block.minecraft.cherry_wall_hanging_sign": "Sakura surmura elpendaĵo",
  "block.minecraft.cherry_wall_sign": "Sakura surmura ŝildeto",
  "block.minecraft.cherry_wood": "Sakura ligno",
  "block.minecraft.chest": "Kofro",
  "block.minecraft.chipped_anvil": "Fendiĝinta amboso",
  "block.minecraft.chiseled_bookshelf": "Ĉizita librobretaro",
  "block.minecraft.chiseled_copper": "Ĉizita kupro",
  "block.minecraft.chiseled_deepslate": "Ĉizita ardezo",
  "block.minecraft.chiseled_nether_bricks": "Ĉizita Nethera brikaro",
  "block.minecraft.chiseled_polished_blackstone": "Ĉizita polurita nigroŝtono",
  "block.minecraft.chiseled_quartz_block": "Ĉizita kvarca bloko",
  "block.minecraft.chiseled_red_sandstone": "Ĉizita ruĝa sabloŝtono",
  "block.minecraft.chiseled_resin_bricks": "Ĉizita rezina brikaro",
  "block.minecraft.chiseled_sandstone": "Ĉizita sabloŝtono",
  "block.minecraft.chiseled_stone_bricks": "Ĉizita ŝtona brikaro",
  "block.minecraft.chiseled_tuff": "Ĉizita tofo",
  "block.minecraft.chiseled_tuff_bricks": "Ĉizita tofa brikaro",
  "block.minecraft.chorus_flower": "Refrena floro",
  "block.minecraft.chorus_plant": "Refrena planto",
  "block.minecraft.clay": "Argilbloko",
  "block.minecraft.closed_eyeblossom": "Dormanta okulfloro",
  "block.minecraft.coal_block": "Karba bloko",
  "block.minecraft.coal_ore": "Karba erco",
  "block.minecraft.coarse_dirt": "Maldelikata tero",
  "block.minecraft.cobbled_deepslate": "Pavimardezo",
  "block.minecraft.cobbled_deepslate_slab": "Pavimardeza ŝtupo",
  "block.minecraft.cobbled_deepslate_stairs": "Pavimardeza ŝtuparo",
  "block.minecraft.cobbled_deepslate_wall": "Pavimardeza muro",
  "block.minecraft.cobblestone": "Pavimŝtono",
  "block.minecraft.cobblestone_slab": "Pavimŝtona ŝtupo",
  "block.minecraft.cobblestone_stairs": "Pavimŝtona ŝtuparo",
  "block.minecraft.cobblestone_wall": "Pavimŝtona muro",
  "block.minecraft.cobweb": "Araneaĵo",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Komanda bloko",
  "block.minecraft.comparator": "Redstone’a komparilo",
  "block.minecraft.composter": "Kompoŝtujo",
  "block.minecraft.conduit": "Markondukto",
  "block.minecraft.copper_bars": "Kupra krado",
  "block.minecraft.copper_block": "Kupra bloko",
  "block.minecraft.copper_bulb": "Kupra ampolo",
  "block.minecraft.copper_chain": "Kupra ĉeno",
  "block.minecraft.copper_chest": "Kupra kofro",
  "block.minecraft.copper_door": "Kupra pordo",
  "block.minecraft.copper_golem_statue": "Kuprogolema statuo",
  "block.minecraft.copper_grate": "Kupra kradaĵo",
  "block.minecraft.copper_lantern": "Kupra lanterno",
  "block.minecraft.copper_ore": "Kupra erco",
  "block.minecraft.copper_torch": "Kupra torĉo",
  "block.minecraft.copper_trapdoor": "Kupra klappordo",
  "block.minecraft.copper_wall_torch": "Surmura kupra torĉo",
  "block.minecraft.cornflower": "Cejano",
  "block.minecraft.cracked_deepslate_bricks": "Rompita ardeza brikaro",
  "block.minecraft.cracked_deepslate_tiles": "Rompita ardeza briketaro",
  "block.minecraft.cracked_nether_bricks": "Rompita Nethera brikaro",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rompita polurita nigroŝtona brikaro",
  "block.minecraft.cracked_stone_bricks": "Rompita ŝtona brikaro",
  "block.minecraft.crafter": "Tujkreilo",
  "block.minecraft.crafting_table": "Labortablo",
  "block.minecraft.creaking_heart": "Krakoro",
  "block.minecraft.creeper_head": "Kapo de Creeper",
  "block.minecraft.creeper_wall_head": "Surmura kapo de Creeper",
  "block.minecraft.crimson_button": "Skarlata prembutono",
  "block.minecraft.crimson_door": "Skarlata pordo",
  "block.minecraft.crimson_fence": "Skarlata barilo",
  "block.minecraft.crimson_fence_gate": "Skarlata barilpordo",
  "block.minecraft.crimson_fungus": "Skarlata fungo",
  "block.minecraft.crimson_hanging_sign": "Skarlata elpendaĵo",
  "block.minecraft.crimson_hyphae": "Skarlata hifaro",
  "block.minecraft.crimson_nylium": "Skarlata nilio",
  "block.minecraft.crimson_planks": "Skarlata tabularo",
  "block.minecraft.crimson_pressure_plate": "Skarlata premplato",
  "block.minecraft.crimson_roots": "Skarlata radikaro",
  "block.minecraft.crimson_shelf": "Skarlata breto",
  "block.minecraft.crimson_sign": "Skarlata ŝildeto",
  "block.minecraft.crimson_slab": "Skarlata ŝtupo",
  "block.minecraft.crimson_stairs": "Skarlata ŝtuparo",
  "block.minecraft.crimson_stem": "Skarlata stipo",
  "block.minecraft.crimson_trapdoor": "Skarlata klappordo",
  "block.minecraft.crimson_wall_hanging_sign": "Skarlata surmura elpendaĵo",
  "block.minecraft.crimson_wall_sign": "Skarlata surmura ŝildeto",
  "block.minecraft.crying_obsidian": "Plorobsidiano",
  "block.minecraft.cut_copper": "Tranĉita kupro",
  "block.minecraft.cut_copper_slab": "Tranĉita kupra ŝtupo",
  "block.minecraft.cut_copper_stairs": "Tranĉita kupra ŝtuparo",
  "block.minecraft.cut_red_sandstone": "Tranĉita ruĝa sabloŝtono",
  "block.minecraft.cut_red_sandstone_slab": "Tranĉita ruĝa sabloŝtona ŝtupo",
  "block.minecraft.cut_sandstone": "Tranĉita sabloŝtono",
  "block.minecraft.cut_sandstone_slab": "Tranĉita sabloŝtona ŝtupo",
  "block.minecraft.cyan_banner": "Turkisa standardo",
  "block.minecraft.cyan_bed": "Turkisa lito",
  "block.minecraft.cyan_candle": "Turkisa kandelo",
  "block.minecraft.cyan_candle_cake": "Torto kun turkisa kandelo",
  "block.minecraft.cyan_carpet": "Turkisa tapiŝo",
  "block.minecraft.cyan_concrete": "Turkisa betono",
  "block.minecraft.cyan_concrete_powder": "Turkisa cemento",
  "block.minecraft.cyan_glazed_terracotta": "Turkisa glazurita terakoto",
  "block.minecraft.cyan_shulker_box": "Turkisa Shulkerskatolo",
  "block.minecraft.cyan_stained_glass": "Turkisigita vitro",
  "block.minecraft.cyan_stained_glass_pane": "Turkisigita glaco",
  "block.minecraft.cyan_terracotta": "Turkisa terakoto",
  "block.minecraft.cyan_wool": "Turkisa lano",
  "block.minecraft.damaged_anvil": "Damaĝita amboso",
  "block.minecraft.dandelion": "Leontodo",
  "block.minecraft.dark_oak_button": "Malhelkverka prembutono",
  "block.minecraft.dark_oak_door": "Malhelkverka pordo",
  "block.minecraft.dark_oak_fence": "Malhelkverka barilo",
  "block.minecraft.dark_oak_fence_gate": "Malhelkverka barilpordo",
  "block.minecraft.dark_oak_hanging_sign": "Malhelkverka elpendaĵo",
  "block.minecraft.dark_oak_leaves": "Malhelkverka foliaro",
  "block.minecraft.dark_oak_log": "Malhelkverka ŝtipo",
  "block.minecraft.dark_oak_planks": "Malhelkverka tabularo",
  "block.minecraft.dark_oak_pressure_plate": "Malhelkverka premplato",
  "block.minecraft.dark_oak_sapling": "Malhelkverkido",
  "block.minecraft.dark_oak_shelf": "Malhelkverka breto",
  "block.minecraft.dark_oak_sign": "Malhelkverka ŝildeto",
  "block.minecraft.dark_oak_slab": "Malhelkverka ŝtupo",
  "block.minecraft.dark_oak_stairs": "Malhelkverka ŝtuparo",
  "block.minecraft.dark_oak_trapdoor": "Malhelkverka klappordo",
  "block.minecraft.dark_oak_wall_hanging_sign": "Malhelkverka surmura elpendaĵo",
  "block.minecraft.dark_oak_wall_sign": "Malhelkverka surmura ŝildeto",
  "block.minecraft.dark_oak_wood": "Malhelkverka ligno",
  "block.minecraft.dark_prismarine": "Malhelprismarino",
  "block.minecraft.dark_prismarine_slab": "Malhelprismarina ŝtupo",
  "block.minecraft.dark_prismarine_stairs": "Malhelprismarina ŝtuparo",
  "block.minecraft.daylight_detector": "Taglumdetektilo",
  "block.minecraft.dead_brain_coral": "Mortinta cerbokoralo",
  "block.minecraft.dead_brain_coral_block": "Mortinta bloko cerbokorala",
  "block.minecraft.dead_brain_coral_fan": "Mortinta ventumilo cerbokorala",
  "block.minecraft.dead_brain_coral_wall_fan": "Mortinta surmura ventumilo cerbokorala",
  "block.minecraft.dead_bubble_coral": "Mortinta bobelokoralo",
  "block.minecraft.dead_bubble_coral_block": "Mortinta bloko bobelokorala",
  "block.minecraft.dead_bubble_coral_fan": "Mortinta ventumilo bobelokorala",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mortinta surmura ventumilo bobelokorala",
  "block.minecraft.dead_bush": "Mortinta arbusto",
  "block.minecraft.dead_fire_coral": "Mortinta fajrokoralo",
  "block.minecraft.dead_fire_coral_block": "Mortinta bloko fajrokorala",
  "block.minecraft.dead_fire_coral_fan": "Mortinta ventumilo fajrokorala",
  "block.minecraft.dead_fire_coral_wall_fan": "Mortinta surmura ventumilo fajrokorala",
  "block.minecraft.dead_horn_coral": "Mortinta kornokoralo",
  "block.minecraft.dead_horn_coral_block": "Mortinta bloko kornokorala",
  "block.minecraft.dead_horn_coral_fan": "Mortinta ventumilo kornokorala",
  "block.minecraft.dead_horn_coral_wall_fan": "Mortinta surmura ventumilo kornokorala",
  "block.minecraft.dead_tube_coral": "Mortinta tubokoralo",
  "block.minecraft.dead_tube_coral_block": "Mortinta bloko tubokorala",
  "block.minecraft.dead_tube_coral_fan": "Mortinta ventumilo tubokorala",
  "block.minecraft.dead_tube_coral_wall_fan": "Mortinta surmura ventumilo tubokorala",
  "block.minecraft.decorated_pot": "Ornamita poto",
  "block.minecraft.deepslate": "Ardezo",
  "block.minecraft.deepslate_brick_slab": "Ardezbrika ŝtupo",
  "block.minecraft.deepslate_brick_stairs": "Ardezbrika ŝtuparo",
  "block.minecraft.deepslate_brick_wall": "Ardezbrika muro",
  "block.minecraft.deepslate_bricks": "Ardeza brikaro",
  "block.minecraft.deepslate_coal_ore": "Ardeza karba erco",
  "block.minecraft.deepslate_copper_ore": "Ardeza kupra erco",
  "block.minecraft.deepslate_diamond_ore": "Ardeza diamanta erco",
  "block.minecraft.deepslate_emerald_ore": "Ardeza smeralda erco",
  "block.minecraft.deepslate_gold_ore": "Ardeza ora erco",
  "block.minecraft.deepslate_iron_ore": "Ardeza fera erco",
  "block.minecraft.deepslate_lapis_ore": "Ardeza lazurita erco",
  "block.minecraft.deepslate_redstone_ore": "Ardeza Redstone’a erco",
  "block.minecraft.deepslate_tile_slab": "Ardeza briketa ŝtupo",
  "block.minecraft.deepslate_tile_stairs": "Ardeza briketa ŝtuparo",
  "block.minecraft.deepslate_tile_wall": "Ardeza briketa muro",
  "block.minecraft.deepslate_tiles": "Ardeza briketaro",
  "block.minecraft.detector_rail": "Detektila relo",
  "block.minecraft.diamond_block": "Diamanta bloko",
  "block.minecraft.diamond_ore": "Diamanta erco",
  "block.minecraft.diorite": "Diorito",
  "block.minecraft.diorite_slab": "Diorita ŝtupo",
  "block.minecraft.diorite_stairs": "Diorita ŝtuparo",
  "block.minecraft.diorite_wall": "Diorita muro",
  "block.minecraft.dirt": "Tero",
  "block.minecraft.dirt_path": "Tera pado",
  "block.minecraft.dispenser": "Ĵetilo",
  "block.minecraft.dragon_egg": "Draka ovo",
  "block.minecraft.dragon_head": "Kapo de drako",
  "block.minecraft.dragon_wall_head": "Surmura kapo de drako",
  "block.minecraft.dried_ghast": "Seka Ghast",
  "block.minecraft.dried_kelp_block": "Sekigita alga bloko",
  "block.minecraft.dripstone_block": "Gutŝtona bloko",
  "block.minecraft.dropper": "Donilo",
  "block.minecraft.emerald_block": "Smeralda bloko",
  "block.minecraft.emerald_ore": "Smeralda erco",
  "block.minecraft.enchanting_table": "Sorĉtablo",
  "block.minecraft.end_gateway": "Enda trairejo",
  "block.minecraft.end_portal": "Endportalo",
  "block.minecraft.end_portal_frame": "Kadro de Endportalo",
  "block.minecraft.end_rod": "Endstango",
  "block.minecraft.end_stone": "Endŝtono",
  "block.minecraft.end_stone_brick_slab": "Endŝtonbrika ŝtupo",
  "block.minecraft.end_stone_brick_stairs": "Endŝtonbrika ŝtuparo",
  "block.minecraft.end_stone_brick_wall": "Endŝtonbrika muro",
  "block.minecraft.end_stone_bricks": "Endŝtona brikaro",
  "block.minecraft.ender_chest": "Enderkofro",
  "block.minecraft.exposed_chiseled_copper": "Verdigreta ĉizita kupro",
  "block.minecraft.exposed_copper": "Verdigreta kupro",
  "block.minecraft.exposed_copper_bars": "Verdigreta kupra krado",
  "block.minecraft.exposed_copper_bulb": "Verdigreta kupra ampolo",
  "block.minecraft.exposed_copper_chain": "Verdigreta kupra ĉeno",
  "block.minecraft.exposed_copper_chest": "Verdigreta kupra kofro",
  "block.minecraft.exposed_copper_door": "Verdigreta kupra pordo",
  "block.minecraft.exposed_copper_golem_statue": "Verdigreta kuprogolema statuo",
  "block.minecraft.exposed_copper_grate": "Verdigreta kupra kradaĵo",
  "block.minecraft.exposed_copper_lantern": "Verdigreta kupra lanterno",
  "block.minecraft.exposed_copper_trapdoor": "Verdigreta kupra klappordo",
  "block.minecraft.exposed_cut_copper": "Verdigreta tranĉita kupro",
  "block.minecraft.exposed_cut_copper_slab": "Verdigreta tranĉita kupra ŝtupo",
  "block.minecraft.exposed_cut_copper_stairs": "Verdigreta tranĉita kupra ŝtuparo",
  "block.minecraft.exposed_lightning_rod": "Verdigreta fulmoŝirmilo",
  "block.minecraft.farmland": "Kultivtero",
  "block.minecraft.fern": "Filiko",
  "block.minecraft.fire": "Fajro",
  "block.minecraft.fire_coral": "Fajrokoralo",
  "block.minecraft.fire_coral_block": "Bloko fajrokorala",
  "block.minecraft.fire_coral_fan": "Ventumilo fajrokorala",
  "block.minecraft.fire_coral_wall_fan": "Surmura ventumilo fajrokorala",
  "block.minecraft.firefly_bush": "Lampira arbusto",
  "block.minecraft.fletching_table": "Pafarktablo",
  "block.minecraft.flower_pot": "Florpoto",
  "block.minecraft.flowering_azalea": "Floranta azaleo",
  "block.minecraft.flowering_azalea_leaves": "Foliaro de floranta azaleo",
  "block.minecraft.frogspawn": "Rana frajo",
  "block.minecraft.frosted_ice": "Prujno",
  "block.minecraft.furnace": "Forno",
  "block.minecraft.gilded_blackstone": "Orita nigroŝtono",
  "block.minecraft.glass": "Vitro",
  "block.minecraft.glass_pane": "Glaco",
  "block.minecraft.glow_lichen": "Lumlikeno",
  "block.minecraft.glowstone": "Lumŝtono",
  "block.minecraft.gold_block": "Ora bloko",
  "block.minecraft.gold_ore": "Ora erco",
  "block.minecraft.golden_dandelion": "Ora leontodo",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Granita ŝtupo",
  "block.minecraft.granite_stairs": "Granita ŝtuparo",
  "block.minecraft.granite_wall": "Granita muro",
  "block.minecraft.grass": "Herbo",
  "block.minecraft.grass_block": "Herba bloko",
  "block.minecraft.gravel": "Gruzo",
  "block.minecraft.gray_banner": "Griza standardo",
  "block.minecraft.gray_bed": "Griza lito",
  "block.minecraft.gray_candle": "Griza kandelo",
  "block.minecraft.gray_candle_cake": "Torto kun griza kandelo",
  "block.minecraft.gray_carpet": "Griza tapiŝo",
  "block.minecraft.gray_concrete": "Griza betono",
  "block.minecraft.gray_concrete_powder": "Griza cemento",
  "block.minecraft.gray_glazed_terracotta": "Griza glazurita terakoto",
  "block.minecraft.gray_shulker_box": "Griza Shulkerskatolo",
  "block.minecraft.gray_stained_glass": "Grizigita vitro",
  "block.minecraft.gray_stained_glass_pane": "Grizigita glaco",
  "block.minecraft.gray_terracotta": "Griza terakoto",
  "block.minecraft.gray_wool": "Griza lano",
  "block.minecraft.green_banner": "Verda standardo",
  "block.minecraft.green_bed": "Verda lito",
  "block.minecraft.green_candle": "Verda kandelo",
  "block.minecraft.green_candle_cake": "Torto kun verda kandelo",
  "block.minecraft.green_carpet": "Verda tapiŝo",
  "block.minecraft.green_concrete": "Verda betono",
  "block.minecraft.green_concrete_powder": "Verda cemento",
  "block.minecraft.green_glazed_terracotta": "Verda glazurita terakoto",
  "block.minecraft.green_shulker_box": "Verda Shulkerskatolo",
  "block.minecraft.green_stained_glass": "Verdigita vitro",
  "block.minecraft.green_stained_glass_pane": "Verdigita glaco",
  "block.minecraft.green_terracotta": "Verda terakoto",
  "block.minecraft.green_wool": "Verda lano",
  "block.minecraft.grindstone": "Akrigilo",
  "block.minecraft.hanging_roots": "Pendanta radikaro",
  "block.minecraft.hay_block": "Pajla pako",
  "block.minecraft.heavy_core": "Madzokapo",
  "block.minecraft.heavy_weighted_pressure_plate": "Peza premplato",
  "block.minecraft.honey_block": "Mielbloko",
  "block.minecraft.honeycomb_block": "Mielĉelarbloko",
  "block.minecraft.hopper": "Funelo",
  "block.minecraft.horn_coral": "Kornokoralo",
  "block.minecraft.horn_coral_block": "Bloko kornokorala",
  "block.minecraft.horn_coral_fan": "Ventumilo kornokorala",
  "block.minecraft.horn_coral_wall_fan": "Surmura ventumilo kornokorala",
  "block.minecraft.ice": "Glacio",
  "block.minecraft.infested_chiseled_stone_bricks": "Infestita ĉizita ŝtona brikaro",
  "block.minecraft.infested_cobblestone": "Infestita pavimŝtono",
  "block.minecraft.infested_cracked_stone_bricks": "Infestita rompita ŝtona brikaro",
  "block.minecraft.infested_deepslate": "Infestita ardezo",
  "block.minecraft.infested_mossy_stone_bricks": "Infestita muska ŝtona brikaro",
  "block.minecraft.infested_stone": "Infestita ŝtono",
  "block.minecraft.infested_stone_bricks": "Infestita ŝtona brikaro",
  "block.minecraft.iron_bars": "Fera krado",
  "block.minecraft.iron_block": "Fera bloko",
  "block.minecraft.iron_chain": "Fera ĉeno",
  "block.minecraft.iron_door": "Fera pordo",
  "block.minecraft.iron_ore": "Fera erco",
  "block.minecraft.iron_trapdoor": "Fera klappordo",
  "block.minecraft.jack_o_lantern": "Kukurba lanterno",
  "block.minecraft.jigsaw": "Konstruktbloko",
  "block.minecraft.jukebox": "Muzikaŭtomato",
  "block.minecraft.jungle_button": "Ĝangalarba prembutono",
  "block.minecraft.jungle_door": "Ĝangalarba pordo",
  "block.minecraft.jungle_fence": "Ĝangalarba barilo",
  "block.minecraft.jungle_fence_gate": "Ĝangalarba barilpordo",
  "block.minecraft.jungle_hanging_sign": "Ĝangalarba elpendaĵo",
  "block.minecraft.jungle_leaves": "Ĝangalarba foliaro",
  "block.minecraft.jungle_log": "Ĝangalarba ŝtipo",
  "block.minecraft.jungle_planks": "Ĝangalarba tabularo",
  "block.minecraft.jungle_pressure_plate": "Ĝangalarba premplato",
  "block.minecraft.jungle_sapling": "Ĝangalarbido",
  "block.minecraft.jungle_shelf": "Ĝangalarba breto",
  "block.minecraft.jungle_sign": "Ĝangalarba ŝildeto",
  "block.minecraft.jungle_slab": "Ĝangalarba ŝtupo",
  "block.minecraft.jungle_stairs": "Ĝangalarba ŝtuparo",
  "block.minecraft.jungle_trapdoor": "Ĝangalarba klappordo",
  "block.minecraft.jungle_wall_hanging_sign": "Ĝangalarba surmura elpendaĵo",
  "block.minecraft.jungle_wall_sign": "Ĝangalarba surmura ŝildeto",
  "block.minecraft.jungle_wood": "Ĝangalarba ligno",
  "block.minecraft.kelp": "Algo",
  "block.minecraft.kelp_plant": "Planto de algo",
  "block.minecraft.ladder": "Ŝtupetaro",
  "block.minecraft.lantern": "Lanterno",
  "block.minecraft.lapis_block": "Lazurita bloko",
  "block.minecraft.lapis_ore": "Lazurita erco",
  "block.minecraft.large_amethyst_bud": "Granda ametista burĝono",
  "block.minecraft.large_fern": "Granda filiko",
  "block.minecraft.lava": "Lafo",
  "block.minecraft.lava_cauldron": "Kaldrono da lafo",
  "block.minecraft.leaf_litter": "Falintaj folioj",
  "block.minecraft.lectern": "Libropupitro",
  "block.minecraft.lever": "Baskulŝaltilo",
  "block.minecraft.light": "Lumo",
  "block.minecraft.light_blue_banner": "Helblua standardo",
  "block.minecraft.light_blue_bed": "Helblua lito",
  "block.minecraft.light_blue_candle": "Helblua kandelo",
  "block.minecraft.light_blue_candle_cake": "Torto kun helblua kandelo",
  "block.minecraft.light_blue_carpet": "Helblua tapiŝo",
  "block.minecraft.light_blue_concrete": "Helblua betono",
  "block.minecraft.light_blue_concrete_powder": "Helblua cemento",
  "block.minecraft.light_blue_glazed_terracotta": "Helblua glazurita terakoto",
  "block.minecraft.light_blue_shulker_box": "Helblua Shulkerskatolo",
  "block.minecraft.light_blue_stained_glass": "Helbluigita vitro",
  "block.minecraft.light_blue_stained_glass_pane": "Helbluigita glaco",
  "block.minecraft.light_blue_terracotta": "Helblua terakoto",
  "block.minecraft.light_blue_wool": "Helblua lano",
  "block.minecraft.light_gray_banner": "Helgriza standardo",
  "block.minecraft.light_gray_bed": "Helgriza lito",
  "block.minecraft.light_gray_candle": "Helgriza kandelo",
  "block.minecraft.light_gray_candle_cake": "Torto kun helgriza kandelo",
  "block.minecraft.light_gray_carpet": "Helgriza tapiŝo",
  "block.minecraft.light_gray_concrete": "Helgriza betono",
  "block.minecraft.light_gray_concrete_powder": "Helgriza cemento",
  "block.minecraft.light_gray_glazed_terracotta": "Helgriza glazurita terakoto",
  "block.minecraft.light_gray_shulker_box": "Helgriza Shulkerskatolo",
  "block.minecraft.light_gray_stained_glass": "Helgrizigita vitro",
  "block.minecraft.light_gray_stained_glass_pane": "Helgrizigita glaco",
  "block.minecraft.light_gray_terracotta": "Helgriza terakoto",
  "block.minecraft.light_gray_wool": "Helgriza lano",
  "block.minecraft.light_weighted_pressure_plate": "Malpeza premplato",
  "block.minecraft.lightning_rod": "Fulmoŝirmilo",
  "block.minecraft.lilac": "Siringo",
  "block.minecraft.lily_of_the_valley": "Konvalo",
  "block.minecraft.lily_pad": "Akvolilio",
  "block.minecraft.lime_banner": "Helverda standardo",
  "block.minecraft.lime_bed": "Helverda lito",
  "block.minecraft.lime_candle": "Helverda kandelo",
  "block.minecraft.lime_candle_cake": "Torto kun helverda kandelo",
  "block.minecraft.lime_carpet": "Helverda tapiŝo",
  "block.minecraft.lime_concrete": "Helverda betono",
  "block.minecraft.lime_concrete_powder": "Helverda cemento",
  "block.minecraft.lime_glazed_terracotta": "Helverda glazurita terakoto",
  "block.minecraft.lime_shulker_box": "Helverda Shulkerskatolo",
  "block.minecraft.lime_stained_glass": "Helverdigita vitro",
  "block.minecraft.lime_stained_glass_pane": "Helverdigita glaco",
  "block.minecraft.lime_terracotta": "Helverda terakoto",
  "block.minecraft.lime_wool": "Helverda lano",
  "block.minecraft.lodestone": "Magnetŝtono",
  "block.minecraft.loom": "Teksilo",
  "block.minecraft.magenta_banner": "Malva standardo",
  "block.minecraft.magenta_bed": "Malva lito",
  "block.minecraft.magenta_candle": "Malva kandelo",
  "block.minecraft.magenta_candle_cake": "Torto kun malva kandelo",
  "block.minecraft.magenta_carpet": "Malva tapiŝo",
  "block.minecraft.magenta_concrete": "Malva betono",
  "block.minecraft.magenta_concrete_powder": "Malva cemento",
  "block.minecraft.magenta_glazed_terracotta": "Malva glazurita terakoto",
  "block.minecraft.magenta_shulker_box": "Malva Shulkerskatolo",
  "block.minecraft.magenta_stained_glass": "Malvigita vitro",
  "block.minecraft.magenta_stained_glass_pane": "Malvigita glaco",
  "block.minecraft.magenta_terracotta": "Malva terakoto",
  "block.minecraft.magenta_wool": "Malva lano",
  "block.minecraft.magma_block": "Magma bloko",
  "block.minecraft.mangrove_button": "Mangla prembutono",
  "block.minecraft.mangrove_door": "Mangla pordo",
  "block.minecraft.mangrove_fence": "Mangla barilo",
  "block.minecraft.mangrove_fence_gate": "Mangla barilpordo",
  "block.minecraft.mangrove_hanging_sign": "Mangla elpendaĵo",
  "block.minecraft.mangrove_leaves": "Mangla foliaro",
  "block.minecraft.mangrove_log": "Mangla ŝtipo",
  "block.minecraft.mangrove_planks": "Mangla tabularo",
  "block.minecraft.mangrove_pressure_plate": "Mangla premplato",
  "block.minecraft.mangrove_propagule": "Mangla propagero",
  "block.minecraft.mangrove_roots": "Mangla radikaro",
  "block.minecraft.mangrove_shelf": "Mangla breto",
  "block.minecraft.mangrove_sign": "Mangla ŝildeto",
  "block.minecraft.mangrove_slab": "Mangla ŝtupo",
  "block.minecraft.mangrove_stairs": "Mangla ŝtuparo",
  "block.minecraft.mangrove_trapdoor": "Mangla klappordo",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangla surmura elpendaĵo",
  "block.minecraft.mangrove_wall_sign": "Mangla surmura ŝildeto",
  "block.minecraft.mangrove_wood": "Mangla ligno",
  "block.minecraft.medium_amethyst_bud": "Mezgranda ametista burĝono",
  "block.minecraft.melon": "Akvomelono",
  "block.minecraft.melon_stem": "Akvomelona tigo",
  "block.minecraft.moss_block": "Muska bloko",
  "block.minecraft.moss_carpet": "Muska tapiŝo",
  "block.minecraft.mossy_cobblestone": "Muska pavimŝtono",
  "block.minecraft.mossy_cobblestone_slab": "Muska pavimŝtona ŝtupo",
  "block.minecraft.mossy_cobblestone_stairs": "Muska pavimŝtona ŝtuparo",
  "block.minecraft.mossy_cobblestone_wall": "Muska pavimŝtona muro",
  "block.minecraft.mossy_stone_brick_slab": "Muska ŝtonbrika ŝtupo",
  "block.minecraft.mossy_stone_brick_stairs": "Muska ŝtonbrika ŝtuparo",
  "block.minecraft.mossy_stone_brick_wall": "Muska ŝtonbrika muro",
  "block.minecraft.mossy_stone_bricks": "Muska ŝtona brikaro",
  "block.minecraft.moving_piston": "Movita bloko",
  "block.minecraft.mud": "Ŝlimo",
  "block.minecraft.mud_brick_slab": "Kotbrika ŝtupo",
  "block.minecraft.mud_brick_stairs": "Kotbrika ŝtuparo",
  "block.minecraft.mud_brick_wall": "Kotbrika muro",
  "block.minecraft.mud_bricks": "Kota brikaro",
  "block.minecraft.muddy_mangrove_roots": "Ŝlimo kun manglaj radikoj",
  "block.minecraft.mushroom_stem": "Fungstipo",
  "block.minecraft.mycelium": "Micelio",
  "block.minecraft.nether_brick_fence": "Netherbrika barilo",
  "block.minecraft.nether_brick_slab": "Netherbrika ŝtupo",
  "block.minecraft.nether_brick_stairs": "Netherbrika ŝtuparo",
  "block.minecraft.nether_brick_wall": "Netherbrika muro",
  "block.minecraft.nether_bricks": "Nethera brikaro",
  "block.minecraft.nether_gold_ore": "Nethera ora erco",
  "block.minecraft.nether_portal": "Netherportalo",
  "block.minecraft.nether_quartz_ore": "Kvarca erco",
  "block.minecraft.nether_sprouts": "Nethera ŝoso",
  "block.minecraft.nether_wart": "Nethera veruko",
  "block.minecraft.nether_wart_block": "Netherveruka bloko",
  "block.minecraft.netherite_block": "Netherite’a bloko",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Notbloko",
  "block.minecraft.oak_button": "Kverka prembutono",
  "block.minecraft.oak_door": "Kverka pordo",
  "block.minecraft.oak_fence": "Kverka barilo",
  "block.minecraft.oak_fence_gate": "Kverka barilpordo",
  "block.minecraft.oak_hanging_sign": "Kverka elpendaĵo",
  "block.minecraft.oak_leaves": "Kverka foliaro",
  "block.minecraft.oak_log": "Kverka ŝtipo",
  "block.minecraft.oak_planks": "Kverka tabularo",
  "block.minecraft.oak_pressure_plate": "Kverka premplato",
  "block.minecraft.oak_sapling": "Kverkido",
  "block.minecraft.oak_shelf": "Kverka breto",
  "block.minecraft.oak_sign": "Kverka ŝildeto",
  "block.minecraft.oak_slab": "Kverka ŝtupo",
  "block.minecraft.oak_stairs": "Kverka ŝtuparo",
  "block.minecraft.oak_trapdoor": "Kverka klappordo",
  "block.minecraft.oak_wall_hanging_sign": "Kverka surmura elpendaĵo",
  "block.minecraft.oak_wall_sign": "Kverka surmura ŝildeto",
  "block.minecraft.oak_wood": "Kverka ligno",
  "block.minecraft.observer": "Observilo",
  "block.minecraft.obsidian": "Obsidiano",
  "block.minecraft.ochre_froglight": "Okra ranterno",
  "block.minecraft.ominous_banner": "Makabra standardo",
  "block.minecraft.open_eyeblossom": "Vekita okulfloro",
  "block.minecraft.orange_banner": "Oranĝkolora standardo",
  "block.minecraft.orange_bed": "Oranĝkolora lito",
  "block.minecraft.orange_candle": "Oranĝkolora kandelo",
  "block.minecraft.orange_candle_cake": "Torto kun oranĝkolora kandelo",
  "block.minecraft.orange_carpet": "Oranĝkolora tapiŝo",
  "block.minecraft.orange_concrete": "Oranĝkolora betono",
  "block.minecraft.orange_concrete_powder": "Oranĝkolora cemento",
  "block.minecraft.orange_glazed_terracotta": "Oranĝkolora glazurita terakoto",
  "block.minecraft.orange_shulker_box": "Oranĝkolora Shulkerskatolo",
  "block.minecraft.orange_stained_glass": "Oranĝkolorigita vitro",
  "block.minecraft.orange_stained_glass_pane": "Oranĝkolorigita glaco",
  "block.minecraft.orange_terracotta": "Oranĝkolora terakoto",
  "block.minecraft.orange_tulip": "Oranĝkolora tulipo",
  "block.minecraft.orange_wool": "Oranĝkolora lano",
  "block.minecraft.oxeye_daisy": "Lekanto",
  "block.minecraft.oxidized_chiseled_copper": "Verdigrega ĉizita kupro",
  "block.minecraft.oxidized_copper": "Verdigrega kupro",
  "block.minecraft.oxidized_copper_bars": "Verdigrega kupra krado",
  "block.minecraft.oxidized_copper_bulb": "Verdigrega kupra ampolo",
  "block.minecraft.oxidized_copper_chain": "Verdigrega kupra ĉeno",
  "block.minecraft.oxidized_copper_chest": "Verdigrega kupra kofro",
  "block.minecraft.oxidized_copper_door": "Verdigrega kupra pordo",
  "block.minecraft.oxidized_copper_golem_statue": "Verdigrega kuprogolema statuo",
  "block.minecraft.oxidized_copper_grate": "Verdigrega kupra kradaĵo",
  "block.minecraft.oxidized_copper_lantern": "Verdigrega kupra lanterno",
  "block.minecraft.oxidized_copper_trapdoor": "Verdigrega kupra klappordo",
  "block.minecraft.oxidized_cut_copper": "Verdigrega tranĉita kupro",
  "block.minecraft.oxidized_cut_copper_slab": "Verdigrega tranĉita kupra ŝtupo",
  "block.minecraft.oxidized_cut_copper_stairs": "Verdigrega tranĉita kupra ŝtuparo",
  "block.minecraft.oxidized_lightning_rod": "Verdigrega fulmoŝirmilo",
  "block.minecraft.packed_ice": "Fortika glacio",
  "block.minecraft.packed_mud": "Fortika koto",
  "block.minecraft.pale_hanging_moss": "Pendanta helmusko",
  "block.minecraft.pale_moss_block": "Helmuska bloko",
  "block.minecraft.pale_moss_carpet": "Helmuska tapiŝo",
  "block.minecraft.pale_oak_button": "Helkverka prembutono",
  "block.minecraft.pale_oak_door": "Helkverka pordo",
  "block.minecraft.pale_oak_fence": "Helkverka barilo",
  "block.minecraft.pale_oak_fence_gate": "Helkverka barilpordo",
  "block.minecraft.pale_oak_hanging_sign": "Helkverka elpendaĵo",
  "block.minecraft.pale_oak_leaves": "Helkverka foliaro",
  "block.minecraft.pale_oak_log": "Helkverka ŝtipo",
  "block.minecraft.pale_oak_planks": "Helkverka tabularo",
  "block.minecraft.pale_oak_pressure_plate": "Helkverka premplato",
  "block.minecraft.pale_oak_sapling": "Helkverkido",
  "block.minecraft.pale_oak_shelf": "Helkverka breto",
  "block.minecraft.pale_oak_sign": "Helkverka ŝildeto",
  "block.minecraft.pale_oak_slab": "Helkverka ŝtupo",
  "block.minecraft.pale_oak_stairs": "Helkverka ŝtuparo",
  "block.minecraft.pale_oak_trapdoor": "Helkverka klappordo",
  "block.minecraft.pale_oak_wall_hanging_sign": "Helkverka surmura elpendaĵo",
  "block.minecraft.pale_oak_wall_sign": "Helkverka surmura ŝildeto",
  "block.minecraft.pale_oak_wood": "Helkverka ligno",
  "block.minecraft.pearlescent_froglight": "Perlamota ranterno",
  "block.minecraft.peony": "Peonio",
  "block.minecraft.petrified_oak_slab": "Ŝtoniĝinta kverka ŝtupo",
  "block.minecraft.piglin_head": "Kapo de Piglin",
  "block.minecraft.piglin_wall_head": "Surmura kapo de Piglin",
  "block.minecraft.pink_banner": "Rozkolora standardo",
  "block.minecraft.pink_bed": "Rozkolora lito",
  "block.minecraft.pink_candle": "Rozkolora kandelo",
  "block.minecraft.pink_candle_cake": "Torto kun rozkolora kandelo",
  "block.minecraft.pink_carpet": "Rozkolora tapiŝo",
  "block.minecraft.pink_concrete": "Rozkolora betono",
  "block.minecraft.pink_concrete_powder": "Rozkolora cemento",
  "block.minecraft.pink_glazed_terracotta": "Rozkolora glazurita terakoto",
  "block.minecraft.pink_petals": "Sakuraj floretoj",
  "block.minecraft.pink_shulker_box": "Rozkolora Shulkerskatolo",
  "block.minecraft.pink_stained_glass": "Rozkolorigita vitro",
  "block.minecraft.pink_stained_glass_pane": "Rozkolorigita glaco",
  "block.minecraft.pink_terracotta": "Rozkolora terakoto",
  "block.minecraft.pink_tulip": "Rozkolora tulipo",
  "block.minecraft.pink_wool": "Rozkolora lano",
  "block.minecraft.piston": "Piŝto",
  "block.minecraft.piston_head": "Piŝtokapo",
  "block.minecraft.pitcher_crop": "Kruĉenia ĝermo",
  "block.minecraft.pitcher_plant": "Kruĉenia planto",
  "block.minecraft.player_head": "Kapo de ludanto",
  "block.minecraft.player_head.named": "Kapo de %s",
  "block.minecraft.player_wall_head": "Surmura kapo de ludanto",
  "block.minecraft.podzol": "Podzolo",
  "block.minecraft.pointed_dripstone": "Pinta gutŝtono",
  "block.minecraft.polished_andesite": "Polurita andezito",
  "block.minecraft.polished_andesite_slab": "Polurita andezita ŝtupo",
  "block.minecraft.polished_andesite_stairs": "Polurita andezita ŝtuparo",
  "block.minecraft.polished_basalt": "Polurita bazalto",
  "block.minecraft.polished_blackstone": "Polurita nigroŝtono",
  "block.minecraft.polished_blackstone_brick_slab": "Polurita nigroŝtonbrika ŝtupo",
  "block.minecraft.polished_blackstone_brick_stairs": "Polurita nigroŝtonbrika ŝtuparo",
  "block.minecraft.polished_blackstone_brick_wall": "Polurita nigroŝtonbrika muro",
  "block.minecraft.polished_blackstone_bricks": "Polurita nigroŝtona brikaro",
  "block.minecraft.polished_blackstone_button": "Polurita nigroŝtona prembutono",
  "block.minecraft.polished_blackstone_pressure_plate": "Polurita nigroŝtona premplato",
  "block.minecraft.polished_blackstone_slab": "Polurita nigroŝtona ŝtupo",
  "block.minecraft.polished_blackstone_stairs": "Polurita nigroŝtona ŝtuparo",
  "block.minecraft.polished_blackstone_wall": "Polurita nigroŝtona muro",
  "block.minecraft.polished_deepslate": "Polurita ardezo",
  "block.minecraft.polished_deepslate_slab": "Polurita ardeza ŝtupo",
  "block.minecraft.polished_deepslate_stairs": "Polurita ardeza ŝtuparo",
  "block.minecraft.polished_deepslate_wall": "Polurita ardeza muro",
  "block.minecraft.polished_diorite": "Polurita diorito",
  "block.minecraft.polished_diorite_slab": "Polurita diorita ŝtupo",
  "block.minecraft.polished_diorite_stairs": "Polurita diorita ŝtuparo",
  "block.minecraft.polished_granite": "Polurita granito",
  "block.minecraft.polished_granite_slab": "Polurita granita ŝtupo",
  "block.minecraft.polished_granite_stairs": "Polurita granita ŝtuparo",
  "block.minecraft.polished_tuff": "Polurita tofo",
  "block.minecraft.polished_tuff_slab": "Polurita tofa ŝtupo",
  "block.minecraft.polished_tuff_stairs": "Polurita tofa ŝtuparo",
  "block.minecraft.polished_tuff_wall": "Polurita tofa muro",
  "block.minecraft.poppy": "Papaveto",
  "block.minecraft.potatoes": "Terpomoj",
  "block.minecraft.potted_acacia_sapling": "Akaciido en florpoto",
  "block.minecraft.potted_allium": "Aliumo en florpoto",
  "block.minecraft.potted_azalea_bush": "Azaleo en florpoto",
  "block.minecraft.potted_azure_bluet": "Blua hustonio en florpoto",
  "block.minecraft.potted_bamboo": "Bambuo en florpoto",
  "block.minecraft.potted_birch_sapling": "Betulido en florpoto",
  "block.minecraft.potted_blue_orchid": "Blua orkido en florpoto",
  "block.minecraft.potted_brown_mushroom": "Boleto en florpoto",
  "block.minecraft.potted_cactus": "Kakto en florpoto",
  "block.minecraft.potted_cherry_sapling": "Sakurido en florpoto",
  "block.minecraft.potted_closed_eyeblossom": "Dormanta okulfloro en florpoto",
  "block.minecraft.potted_cornflower": "Cejano en florpoto",
  "block.minecraft.potted_crimson_fungus": "Skarlata fungo en florpoto",
  "block.minecraft.potted_crimson_roots": "Skarlata radikaro en florpoto",
  "block.minecraft.potted_dandelion": "Leontodo en florpoto",
  "block.minecraft.potted_dark_oak_sapling": "Malhelkverkido en florpoto",
  "block.minecraft.potted_dead_bush": "Mortinta arbusto en florpoto",
  "block.minecraft.potted_fern": "Filiko en florpoto",
  "block.minecraft.potted_flowering_azalea_bush": "Floranta azaleo en florpoto",
  "block.minecraft.potted_golden_dandelion": "Ora leontodo en florpoto",
  "block.minecraft.potted_jungle_sapling": "Ĝangalarbido en florpoto",
  "block.minecraft.potted_lily_of_the_valley": "Konvalo en florpoto",
  "block.minecraft.potted_mangrove_propagule": "Mangla propagero en florpoto",
  "block.minecraft.potted_oak_sapling": "Kverkido en florpoto",
  "block.minecraft.potted_open_eyeblossom": "Vekita okulfloro en florpoto",
  "block.minecraft.potted_orange_tulip": "Oranĝkolora tulipo en florpoto",
  "block.minecraft.potted_oxeye_daisy": "Lekanto en florpoto",
  "block.minecraft.potted_pale_oak_sapling": "Helkverkido en florpoto",
  "block.minecraft.potted_pink_tulip": "Rozkolora tulipo en florpoto",
  "block.minecraft.potted_poppy": "Papaveto en florpoto",
  "block.minecraft.potted_red_mushroom": "Muŝfungo en florpoto",
  "block.minecraft.potted_red_tulip": "Ruĝa tulipo en florpoto",
  "block.minecraft.potted_spruce_sapling": "Piceido en florpoto",
  "block.minecraft.potted_torchflower": "Torĉfloro en florpoto",
  "block.minecraft.potted_warped_fungus": "Torda fungo en florpoto",
  "block.minecraft.potted_warped_roots": "Torda radikaro en florpoto",
  "block.minecraft.potted_white_tulip": "Blanka tulipo en florpoto",
  "block.minecraft.potted_wither_rose": "Witherrozo en florpoto",
  "block.minecraft.powder_snow": "Pulvora neĝo",
  "block.minecraft.powder_snow_cauldron": "Kaldrono da pulvora neĝo",
  "block.minecraft.powered_rail": "Elektra relo",
  "block.minecraft.prismarine": "Prismarino",
  "block.minecraft.prismarine_brick_slab": "Prismarinbrika ŝtupo",
  "block.minecraft.prismarine_brick_stairs": "Prismarinbrika ŝtuparo",
  "block.minecraft.prismarine_bricks": "Prismarina brikaro",
  "block.minecraft.prismarine_slab": "Prismarina ŝtupo",
  "block.minecraft.prismarine_stairs": "Prismarina ŝtuparo",
  "block.minecraft.prismarine_wall": "Prismarina muro",
  "block.minecraft.pumpkin": "Kukurbo",
  "block.minecraft.pumpkin_stem": "Kukurba tigo",
  "block.minecraft.purple_banner": "Violkolora standardo",
  "block.minecraft.purple_bed": "Violkolora lito",
  "block.minecraft.purple_candle": "Violkolora kandelo",
  "block.minecraft.purple_candle_cake": "Torto kun violkolora kandelo",
  "block.minecraft.purple_carpet": "Violkolora tapiŝo",
  "block.minecraft.purple_concrete": "Violkolora betono",
  "block.minecraft.purple_concrete_powder": "Violkolora cemento",
  "block.minecraft.purple_glazed_terracotta": "Violkolora glazurita terakoto",
  "block.minecraft.purple_shulker_box": "Violkolora Shulkerskatolo",
  "block.minecraft.purple_stained_glass": "Violkolorigita vitro",
  "block.minecraft.purple_stained_glass_pane": "Violkolorigita glaco",
  "block.minecraft.purple_terracotta": "Violkolora terakoto",
  "block.minecraft.purple_wool": "Violkolora lano",
  "block.minecraft.purpur_block": "Purpura bloko",
  "block.minecraft.purpur_pillar": "Purpura paliso",
  "block.minecraft.purpur_slab": "Purpura ŝtupo",
  "block.minecraft.purpur_stairs": "Purpura ŝtuparo",
  "block.minecraft.quartz_block": "Kvarca bloko",
  "block.minecraft.quartz_bricks": "Kvarca brikaro",
  "block.minecraft.quartz_pillar": "Kvarca paliso",
  "block.minecraft.quartz_slab": "Kvarca ŝtupo",
  "block.minecraft.quartz_stairs": "Kvarca ŝtuparo",
  "block.minecraft.rail": "Relo",
  "block.minecraft.raw_copper_block": "Krudkupra bloko",
  "block.minecraft.raw_gold_block": "Krudora bloko",
  "block.minecraft.raw_iron_block": "Krudfera bloko",
  "block.minecraft.red_banner": "Ruĝa standardo",
  "block.minecraft.red_bed": "Ruĝa lito",
  "block.minecraft.red_candle": "Ruĝa kandelo",
  "block.minecraft.red_candle_cake": "Torto kun ruĝa kandelo",
  "block.minecraft.red_carpet": "Ruĝa tapiŝo",
  "block.minecraft.red_concrete": "Ruĝa betono",
  "block.minecraft.red_concrete_powder": "Ruĝa cemento",
  "block.minecraft.red_glazed_terracotta": "Ruĝa glazurita terakoto",
  "block.minecraft.red_mushroom": "Muŝfungo",
  "block.minecraft.red_mushroom_block": "Muŝfunga bloko",
  "block.minecraft.red_nether_brick_slab": "Ruĝa Netherbrika ŝtupo",
  "block.minecraft.red_nether_brick_stairs": "Ruĝa Netherbrika ŝtuparo",
  "block.minecraft.red_nether_brick_wall": "Ruĝa Netherbrika muro",
  "block.minecraft.red_nether_bricks": "Ruĝa Nethera brikaro",
  "block.minecraft.red_sand": "Ruĝa sablo",
  "block.minecraft.red_sandstone": "Ruĝa sabloŝtono",
  "block.minecraft.red_sandstone_slab": "Ruĝa sabloŝtona ŝtupo",
  "block.minecraft.red_sandstone_stairs": "Ruĝa sabloŝtona ŝtuparo",
  "block.minecraft.red_sandstone_wall": "Ruĝa sabloŝtona muro",
  "block.minecraft.red_shulker_box": "Ruĝa Shulkerskatolo",
  "block.minecraft.red_stained_glass": "Ruĝigita vitro",
  "block.minecraft.red_stained_glass_pane": "Ruĝigita glaco",
  "block.minecraft.red_terracotta": "Ruĝa terakoto",
  "block.minecraft.red_tulip": "Ruĝa tulipo",
  "block.minecraft.red_wool": "Ruĝa lano",
  "block.minecraft.redstone_block": "Redstone’a bloko",
  "block.minecraft.redstone_lamp": "Redstone’a lampo",
  "block.minecraft.redstone_ore": "Redstone’a erco",
  "block.minecraft.redstone_torch": "Redstone’a torĉo",
  "block.minecraft.redstone_wall_torch": "Redstone’a surmura torĉo",
  "block.minecraft.redstone_wire": "Redstone’a pado",
  "block.minecraft.reinforced_deepslate": "Armita ardezo",
  "block.minecraft.repeater": "Redstone’a ripetilo",
  "block.minecraft.repeating_command_block": "Ripeta komanda bloko",
  "block.minecraft.resin_block": "Rezina bloko",
  "block.minecraft.resin_brick_slab": "Rezinbrika ŝtupo",
  "block.minecraft.resin_brick_stairs": "Rezinbrika ŝtuparo",
  "block.minecraft.resin_brick_wall": "Rezinbrika muro",
  "block.minecraft.resin_bricks": "Rezina brikaro",
  "block.minecraft.resin_clump": "Rezina koagulaĵo",
  "block.minecraft.respawn_anchor": "Reaperankro",
  "block.minecraft.rooted_dirt": "Radika tero",
  "block.minecraft.rose_bush": "Rozarbusto",
  "block.minecraft.sand": "Sablo",
  "block.minecraft.sandstone": "Sabloŝtono",
  "block.minecraft.sandstone_slab": "Sabloŝtona ŝtupo",
  "block.minecraft.sandstone_stairs": "Sabloŝtona ŝtuparo",
  "block.minecraft.sandstone_wall": "Sabloŝtona muro",
  "block.minecraft.scaffolding": "Skafaldo",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculka katalizilo",
  "block.minecraft.sculk_sensor": "Sculka sensoro",
  "block.minecraft.sculk_shrieker": "Sculka kriilo",
  "block.minecraft.sculk_vein": "Sculka vejnaro",
  "block.minecraft.sea_lantern": "Marlanterno",
  "block.minecraft.sea_pickle": "Holoturio",
  "block.minecraft.seagrass": "Marherbo",
  "block.minecraft.set_spawn": "Reaperejo ŝanĝiĝis",
  "block.minecraft.short_dry_grass": "Malalta seka herbo",
  "block.minecraft.short_grass": "Malalta herbo",
  "block.minecraft.shroomlight": "Lumfungo",
  "block.minecraft.shulker_box": "Shulkerskatolo",
  "block.minecraft.skeleton_skull": "Kranio de skeleto",
  "block.minecraft.skeleton_wall_skull": "Surmura kranio de skeleto",
  "block.minecraft.slime_block": "Mukbloko",
  "block.minecraft.small_amethyst_bud": "Malgranda ametista burĝono",
  "block.minecraft.small_dripleaf": "Gutfolieto",
  "block.minecraft.smithing_table": "Fandtablo",
  "block.minecraft.smoker": "Fumilo",
  "block.minecraft.smooth_basalt": "Glata bazalto",
  "block.minecraft.smooth_quartz": "Glata kvarca bloko",
  "block.minecraft.smooth_quartz_slab": "Glata kvarca ŝtupo",
  "block.minecraft.smooth_quartz_stairs": "Glata kvarca ŝtuparo",
  "block.minecraft.smooth_red_sandstone": "Glata ruĝa sabloŝtono",
  "block.minecraft.smooth_red_sandstone_slab": "Glata ruĝa sabloŝtona ŝtupo",
  "block.minecraft.smooth_red_sandstone_stairs": "Glata ruĝa sabloŝtona ŝtuparo",
  "block.minecraft.smooth_sandstone": "Glata sabloŝtono",
  "block.minecraft.smooth_sandstone_slab": "Glata sabloŝtona ŝtupo",
  "block.minecraft.smooth_sandstone_stairs": "Glata sabloŝtona ŝtuparo",
  "block.minecraft.smooth_stone": "Glata ŝtono",
  "block.minecraft.smooth_stone_slab": "Glata ŝtona ŝtupo",
  "block.minecraft.sniffer_egg": "Snuflara ovo",
  "block.minecraft.snow": "Neĝo",
  "block.minecraft.snow_block": "Neĝa bloko",
  "block.minecraft.soul_campfire": "Anima tendarfajro",
  "block.minecraft.soul_fire": "Anima fajro",
  "block.minecraft.soul_lantern": "Anima lanterno",
  "block.minecraft.soul_sand": "Animsablo",
  "block.minecraft.soul_soil": "Animtero",
  "block.minecraft.soul_torch": "Anima torĉo",
  "block.minecraft.soul_wall_torch": "Surmura anima torĉo",
  "block.minecraft.spawn.not_valid": "Vi ne havas hejmliton nek ŝargitan reaperankron, aŭ ĝi blokiĝis",
  "block.minecraft.spawner": "Monstra generilo",
  "block.minecraft.spawner.desc1": "Alklakite per aperigovo",
  "block.minecraft.spawner.desc2": "ĝi agordas mobtipon",
  "block.minecraft.sponge": "Spongo",
  "block.minecraft.spore_blossom": "Sporfloro",
  "block.minecraft.spruce_button": "Picea prembutono",
  "block.minecraft.spruce_door": "Picea pordo",
  "block.minecraft.spruce_fence": "Picea barilo",
  "block.minecraft.spruce_fence_gate": "Picea barilpordo",
  "block.minecraft.spruce_hanging_sign": "Picea elpendaĵo",
  "block.minecraft.spruce_leaves": "Picea foliaro",
  "block.minecraft.spruce_log": "Picea ŝtipo",
  "block.minecraft.spruce_planks": "Picea tabularo",
  "block.minecraft.spruce_pressure_plate": "Picea premplato",
  "block.minecraft.spruce_sapling": "Piceido",
  "block.minecraft.spruce_shelf": "Picea breto",
  "block.minecraft.spruce_sign": "Picea ŝildeto",
  "block.minecraft.spruce_slab": "Picea ŝtupo",
  "block.minecraft.spruce_stairs": "Picea ŝtuparo",
  "block.minecraft.spruce_trapdoor": "Picea klappordo",
  "block.minecraft.spruce_wall_hanging_sign": "Picea surmura elpendaĵo",
  "block.minecraft.spruce_wall_sign": "Picea surmura ŝildeto",
  "block.minecraft.spruce_wood": "Picea ligno",
  "block.minecraft.sticky_piston": "Adhera piŝto",
  "block.minecraft.stone": "Ŝtono",
  "block.minecraft.stone_brick_slab": "Ŝtonbrika ŝtupo",
  "block.minecraft.stone_brick_stairs": "Ŝtonbrika ŝtuparo",
  "block.minecraft.stone_brick_wall": "Ŝtonbrika muro",
  "block.minecraft.stone_bricks": "Ŝtona brikaro",
  "block.minecraft.stone_button": "Ŝtona prembutono",
  "block.minecraft.stone_pressure_plate": "Ŝtona premplato",
  "block.minecraft.stone_slab": "Ŝtona ŝtupo",
  "block.minecraft.stone_stairs": "Ŝtona ŝtuparo",
  "block.minecraft.stonecutter": "Ŝtontranĉilo",
  "block.minecraft.stripped_acacia_log": "Senŝela akacia ŝtipo",
  "block.minecraft.stripped_acacia_wood": "Senŝela akacia ligno",
  "block.minecraft.stripped_bamboo_block": "Senŝela bambua bloko",
  "block.minecraft.stripped_birch_log": "Senŝela betula ŝtipo",
  "block.minecraft.stripped_birch_wood": "Senŝela betula ligno",
  "block.minecraft.stripped_cherry_log": "Senŝela sakura ŝtipo",
  "block.minecraft.stripped_cherry_wood": "Senŝela sakura ligno",
  "block.minecraft.stripped_crimson_hyphae": "Senŝela skarlata hifaro",
  "block.minecraft.stripped_crimson_stem": "Senŝela skarlata stipo",
  "block.minecraft.stripped_dark_oak_log": "Senŝela malhelkverka ŝtipo",
  "block.minecraft.stripped_dark_oak_wood": "Senŝela malhelkverka ligno",
  "block.minecraft.stripped_jungle_log": "Senŝela ĝangalarba ŝtipo",
  "block.minecraft.stripped_jungle_wood": "Senŝela ĝangalarba ligno",
  "block.minecraft.stripped_mangrove_log": "Senŝela mangla ŝtipo",
  "block.minecraft.stripped_mangrove_wood": "Senŝela mangla ligno",
  "block.minecraft.stripped_oak_log": "Senŝela kverka ŝtipo",
  "block.minecraft.stripped_oak_wood": "Senŝela kverka ligno",
  "block.minecraft.stripped_pale_oak_log": "Senŝela helkverka ŝtipo",
  "block.minecraft.stripped_pale_oak_wood": "Senŝela helkverka ligno",
  "block.minecraft.stripped_spruce_log": "Senŝela picea ŝtipo",
  "block.minecraft.stripped_spruce_wood": "Senŝela picea ligno",
  "block.minecraft.stripped_warped_hyphae": "Senŝela torda hifaro",
  "block.minecraft.stripped_warped_stem": "Senŝela torda stipo",
  "block.minecraft.structure_block": "Strukturbloko",
  "block.minecraft.structure_void": "Strukturvakuo",
  "block.minecraft.sugar_cane": "Sukerkano",
  "block.minecraft.sunflower": "Sunfloro",
  "block.minecraft.suspicious_gravel": "Suspektinda gruzo",
  "block.minecraft.suspicious_sand": "Suspektinda sablo",
  "block.minecraft.sweet_berry_bush": "Dolĉbera arbusto",
  "block.minecraft.tall_dry_grass": "Alta seka herbo",
  "block.minecraft.tall_grass": "Alta herbo",
  "block.minecraft.tall_seagrass": "Alta marherbo",
  "block.minecraft.target": "Pafcelo",
  "block.minecraft.terracotta": "Terakoto",
  "block.minecraft.test_block": "Testa bloko",
  "block.minecraft.test_instance_block": "Test-ekzemplera bloko",
  "block.minecraft.tinted_glass": "Malluma vitro",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Eksplodoj de TNT estas malebligitaj",
  "block.minecraft.torch": "Torĉo",
  "block.minecraft.torchflower": "Torĉfloro",
  "block.minecraft.torchflower_crop": "Torĉflora ĝermo",
  "block.minecraft.trapped_chest": "Baskulkofro",
  "block.minecraft.trial_spawner": "Defia generilo",
  "block.minecraft.tripwire": "Insiddrato",
  "block.minecraft.tripwire_hook": "Hoko por insiddrato",
  "block.minecraft.tube_coral": "Tubokoralo",
  "block.minecraft.tube_coral_block": "Bloko tubokorala",
  "block.minecraft.tube_coral_fan": "Ventumilo tubokorala",
  "block.minecraft.tube_coral_wall_fan": "Surmura ventumilo tubokorala",
  "block.minecraft.tuff": "Tofo",
  "block.minecraft.tuff_brick_slab": "Tofbrika ŝtupo",
  "block.minecraft.tuff_brick_stairs": "Tofbrika ŝtuparo",
  "block.minecraft.tuff_brick_wall": "Tofbrika muro",
  "block.minecraft.tuff_bricks": "Tofa brikaro",
  "block.minecraft.tuff_slab": "Tofa ŝtupo",
  "block.minecraft.tuff_stairs": "Tofa ŝtuparo",
  "block.minecraft.tuff_wall": "Tofa muro",
  "block.minecraft.turtle_egg": "Testuda ovo",
  "block.minecraft.twisting_vines": "Serpentanta hedero",
  "block.minecraft.twisting_vines_plant": "Planto de serpentanta hedero",
  "block.minecraft.vault": "Trezorujo",
  "block.minecraft.verdant_froglight": "Malakita ranterno",
  "block.minecraft.vine": "Liano",
  "block.minecraft.void_air": "Vakueja aero",
  "block.minecraft.wall_torch": "Surmura torĉo",
  "block.minecraft.warped_button": "Torda prembutono",
  "block.minecraft.warped_door": "Torda pordo",
  "block.minecraft.warped_fence": "Torda barilo",
  "block.minecraft.warped_fence_gate": "Torda barilpordo",
  "block.minecraft.warped_fungus": "Torda fungo",
  "block.minecraft.warped_hanging_sign": "Torda elpendaĵo",
  "block.minecraft.warped_hyphae": "Torda hifaro",
  "block.minecraft.warped_nylium": "Torda nilio",
  "block.minecraft.warped_planks": "Torda tabularo",
  "block.minecraft.warped_pressure_plate": "Torda premplato",
  "block.minecraft.warped_roots": "Torda radikaro",
  "block.minecraft.warped_shelf": "Torda breto",
  "block.minecraft.warped_sign": "Torda ŝildeto",
  "block.minecraft.warped_slab": "Torda ŝtupo",
  "block.minecraft.warped_stairs": "Torda ŝtuparo",
  "block.minecraft.warped_stem": "Torda stipo",
  "block.minecraft.warped_trapdoor": "Torda klappordo",
  "block.minecraft.warped_wall_hanging_sign": "Torda surmura elpendaĵo",
  "block.minecraft.warped_wall_sign": "Torda surmura ŝildeto",
  "block.minecraft.warped_wart_block": "Torda Netherveruka bloko",
  "block.minecraft.water": "Akvo",
  "block.minecraft.water_cauldron": "Kaldrono da akvo",
  "block.minecraft.waxed_chiseled_copper": "Vaksita ĉizita kupro",
  "block.minecraft.waxed_copper_bars": "Vaksita kupra krado",
  "block.minecraft.waxed_copper_block": "Vaksita kupra bloko",
  "block.minecraft.waxed_copper_bulb": "Vaksita kupra ampolo",
  "block.minecraft.waxed_copper_chain": "Vaksita kupra ĉeno",
  "block.minecraft.waxed_copper_chest": "Vaksita kupra kofro",
  "block.minecraft.waxed_copper_door": "Vaksita kupra pordo",
  "block.minecraft.waxed_copper_golem_statue": "Vaksita kuprogolema statuo",
  "block.minecraft.waxed_copper_grate": "Vaksita kupra kradaĵo",
  "block.minecraft.waxed_copper_lantern": "Vaksita kupra lanterno",
  "block.minecraft.waxed_copper_trapdoor": "Vaksita kupra klappordo",
  "block.minecraft.waxed_cut_copper": "Vaksita tranĉita kupro",
  "block.minecraft.waxed_cut_copper_slab": "Vaksita tranĉita kupra ŝtupo",
  "block.minecraft.waxed_cut_copper_stairs": "Vaksita tranĉita kupra ŝtuparo",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaksita verdigreta ĉizita kupro",
  "block.minecraft.waxed_exposed_copper": "Vaksita verdigreta kupro",
  "block.minecraft.waxed_exposed_copper_bars": "Vaksita verdigreta kupra krado",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaksita verdigreta kupra ampolo",
  "block.minecraft.waxed_exposed_copper_chain": "Vaksita verdigreta kupra ĉeno",
  "block.minecraft.waxed_exposed_copper_chest": "Vaksita verdigreta kupra kofro",
  "block.minecraft.waxed_exposed_copper_door": "Vaksita verdigreta kupra pordo",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaksita verdigreta kuprogolema statuo",
  "block.minecraft.waxed_exposed_copper_grate": "Vaksita verdigreta kupra kradaĵo",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaksita verdigreta kupra lanterno",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaksita verdigreta kupra klappordo",
  "block.minecraft.waxed_exposed_cut_copper": "Vaksita verdigreta tranĉita kupro",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaksita verdigreta tranĉita kupra ŝtupo",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaksita verdigreta tranĉita kupra ŝtuparo",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaksita verdigreta fulmoŝirmilo",
  "block.minecraft.waxed_lightning_rod": "Vaksita fulmoŝirmilo",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaksita verdigrega ĉizita kupro",
  "block.minecraft.waxed_oxidized_copper": "Vaksita verdigrega kupro",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaksita verdigrega kupra krado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaksita verdigrega kupra ampolo",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaksita verdigrega kupra ĉeno",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaksita verdigrega kupra kofro",
  "block.minecraft.waxed_oxidized_copper_door": "Vaksita verdigrega kupra pordo",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaksita verdigrega kuprogolema statuo",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaksita verdigrega kupra kradaĵo",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaksita verdigrega kupra lanterno",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaksita verdigrega kupra klappordo",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaksita verdigrega tranĉita kupro",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaksita verdigrega tranĉita kupra ŝtupo",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaksita verdigrega tranĉita kupra ŝtuparo",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaksita verdigrega fulmoŝirmilo",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaksita verdigra ĉizita kupro",
  "block.minecraft.waxed_weathered_copper": "Vaksita verdigra kupro",
  "block.minecraft.waxed_weathered_copper_bars": "Vaksita verdigra kupra krado",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaksita verdigra kupra ampolo",
  "block.minecraft.waxed_weathered_copper_chain": "Vaksita verdigra kupra ĉeno",
  "block.minecraft.waxed_weathered_copper_chest": "Vaksita verdigra kupra kofro",
  "block.minecraft.waxed_weathered_copper_door": "Vaksita verdigra kupra pordo",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaksita verdigra kuprogolema statuo",
  "block.minecraft.waxed_weathered_copper_grate": "Vaksita verdigra kupra kradaĵo",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaksita verdigra kupra lanterno",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaksita verdigra kupra klappordo",
  "block.minecraft.waxed_weathered_cut_copper": "Vaksita verdigra tranĉita kupro",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaksita verdigra tranĉita kupra ŝtupo",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaksita verdigra tranĉita kupra ŝtuparo",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaksita verdigra fulmoŝirmilo",
  "block.minecraft.weathered_chiseled_copper": "Verdigra ĉizita kupro",
  "block.minecraft.weathered_copper": "Verdigra kupro",
  "block.minecraft.weathered_copper_bars": "Verdigra kupra krado",
  "block.minecraft.weathered_copper_bulb": "Verdigra kupra ampolo",
  "block.minecraft.weathered_copper_chain": "Verdigra kupra ĉeno",
  "block.minecraft.weathered_copper_chest": "Verdigra kupra kofro",
  "block.minecraft.weathered_copper_door": "Verdigra kupra pordo",
  "block.minecraft.weathered_copper_golem_statue": "Verdigra kuprogolema statuo",
  "block.minecraft.weathered_copper_grate": "Verdigra kupra kradaĵo",
  "block.minecraft.weathered_copper_lantern": "Verdigra kupra lanterno",
  "block.minecraft.weathered_copper_trapdoor": "Verdigra kupra klappordo",
  "block.minecraft.weathered_cut_copper": "Verdigra tranĉita kupro",
  "block.minecraft.weathered_cut_copper_slab": "Verdigra tranĉita kupra ŝtupo",
  "block.minecraft.weathered_cut_copper_stairs": "Verdigra tranĉita kupra ŝtuparo",
  "block.minecraft.weathered_lightning_rod": "Verdigra fulmoŝirmilo",
  "block.minecraft.weeping_vines": "Larmanta hedero",
  "block.minecraft.weeping_vines_plant": "Planto de larmanta hedero",
  "block.minecraft.wet_sponge": "Malseka spongo",
  "block.minecraft.wheat": "Tritika semitaĵo",
  "block.minecraft.white_banner": "Blanka standardo",
  "block.minecraft.white_bed": "Blanka lito",
  "block.minecraft.white_candle": "Blanka kandelo",
  "block.minecraft.white_candle_cake": "Torto kun blanka kandelo",
  "block.minecraft.white_carpet": "Blanka tapiŝo",
  "block.minecraft.white_concrete": "Blanka betono",
  "block.minecraft.white_concrete_powder": "Blanka cemento",
  "block.minecraft.white_glazed_terracotta": "Blanka glazurita terakoto",
  "block.minecraft.white_shulker_box": "Blanka Shulkerskatolo",
  "block.minecraft.white_stained_glass": "Blankigita vitro",
  "block.minecraft.white_stained_glass_pane": "Blankigita glaco",
  "block.minecraft.white_terracotta": "Blanka terakoto",
  "block.minecraft.white_tulip": "Blanka tulipo",
  "block.minecraft.white_wool": "Blanka lano",
  "block.minecraft.wildflowers": "Sovaĝaj floroj",
  "block.minecraft.wither_rose": "Witherrozo",
  "block.minecraft.wither_skeleton_skull": "Kranio de Witherskeleto",
  "block.minecraft.wither_skeleton_wall_skull": "Surmura kranio de Witherskeleto",
  "block.minecraft.yellow_banner": "Flava standardo",
  "block.minecraft.yellow_bed": "Flava lito",
  "block.minecraft.yellow_candle": "Flava kandelo",
  "block.minecraft.yellow_candle_cake": "Torto kun flava kandelo",
  "block.minecraft.yellow_carpet": "Flava tapiŝo",
  "block.minecraft.yellow_concrete": "Flava betono",
  "block.minecraft.yellow_concrete_powder": "Flava cemento",
  "block.minecraft.yellow_glazed_terracotta": "Flava glazurita terakoto",
  "block.minecraft.yellow_shulker_box": "Flava Shulkerskatolo",
  "block.minecraft.yellow_stained_glass": "Flavigita vitro",
  "block.minecraft.yellow_stained_glass_pane": "Flavigita glaco",
  "block.minecraft.yellow_terracotta": "Flava terakoto",
  "block.minecraft.yellow_wool": "Flava lano",
  "block.minecraft.zombie_head": "Kapo de zombio",
  "block.minecraft.zombie_wall_head": "Surmura kapo de zombio",
  "item.minecraft.acacia_boat": "Akacia boato",
  "item.minecraft.acacia_chest_boat": "Akacia boato kun kofro",
  "item.minecraft.allay_spawn_egg": "Aperigovo de mildulo",
  "item.minecraft.amethyst_shard": "Fragmento de ametisto",
  "item.minecraft.angler_pottery_shard": "Potpeco «Fiŝkaptilo»",
  "item.minecraft.angler_pottery_sherd": "Potpeco «Fiŝkaptilo»",
  "item.minecraft.apple": "Pomo",
  "item.minecraft.archer_pottery_shard": "Potpeco «Pafarko»",
  "item.minecraft.archer_pottery_sherd": "Potpeco «Pafarko»",
  "item.minecraft.armadillo_scute": "Ŝelero de dazipo",
  "item.minecraft.armadillo_spawn_egg": "Aperigovo de dazipo",
  "item.minecraft.armor_stand": "Armaĵa tenilo",
  "item.minecraft.arms_up_pottery_shard": "Potpeco «Manlevo»",
  "item.minecraft.arms_up_pottery_sherd": "Potpeco «Manlevo»",
  "item.minecraft.arrow": "Sago",
  "item.minecraft.axolotl_bucket": "Sitelo kun aksolotlo",
  "item.minecraft.axolotl_spawn_egg": "Aperigovo de aksolotlo",
  "item.minecraft.baked_potato": "Bakita terpomo",
  "item.minecraft.bamboo_chest_raft": "Bambua floso kun kofro",
  "item.minecraft.bamboo_raft": "Bambua floso",
  "item.minecraft.bat_spawn_egg": "Aperigovo de vesperto",
  "item.minecraft.bee_spawn_egg": "Aperigovo de abelo",
  "item.minecraft.beef": "Kruda bovaĵo",
  "item.minecraft.beetroot": "Ruĝbeto",
  "item.minecraft.beetroot_seeds": "Ruĝbetaj semoj",
  "item.minecraft.beetroot_soup": "Barĉo",
  "item.minecraft.birch_boat": "Betula boato",
  "item.minecraft.birch_chest_boat": "Betula boato kun kofro",
  "item.minecraft.black_bundle": "Nigra sako",
  "item.minecraft.black_dye": "Nigra tinkturo",
  "item.minecraft.black_harness": "Nigra jungilaro",
  "item.minecraft.blade_pottery_shard": "Potpeco «Klingo»",
  "item.minecraft.blade_pottery_sherd": "Potpeco «Klingo»",
  "item.minecraft.blaze_powder": "Incendia pulvoro",
  "item.minecraft.blaze_rod": "Incendia vergo",
  "item.minecraft.blaze_spawn_egg": "Aperigovo de incendio",
  "item.minecraft.blue_bundle": "Blua sako",
  "item.minecraft.blue_dye": "Blua tinkturo",
  "item.minecraft.blue_egg": "Blua ovo",
  "item.minecraft.blue_harness": "Blua jungilaro",
  "item.minecraft.bogged_spawn_egg": "Aperigovo de sinkinto",
  "item.minecraft.bolt_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Inkrustaĵo «Fulmo»",
  "item.minecraft.bone": "Osto",
  "item.minecraft.bone_meal": "Osta faruno",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Standarda ŝablono «Ondumo»",
  "item.minecraft.bow": "Pafarko",
  "item.minecraft.bowl": "Bovlo",
  "item.minecraft.bread": "Pano",
  "item.minecraft.breeze_rod": "Uragana vergo",
  "item.minecraft.breeze_spawn_egg": "Aperigovo de uragano",
  "item.minecraft.brewer_pottery_shard": "Potpeco «Eliksiro»",
  "item.minecraft.brewer_pottery_sherd": "Potpeco «Eliksiro»",
  "item.minecraft.brewing_stand": "Eliksirfarilo",
  "item.minecraft.brick": "Briko",
  "item.minecraft.brown_bundle": "Bruna sako",
  "item.minecraft.brown_dye": "Bruna tinkturo",
  "item.minecraft.brown_egg": "Bruna ovo",
  "item.minecraft.brown_harness": "Bruna jungilaro",
  "item.minecraft.brush": "Broso",
  "item.minecraft.bucket": "Sitelo",
  "item.minecraft.bundle": "Sako",
  "item.minecraft.bundle.empty": "Malplena",
  "item.minecraft.bundle.empty.description": "Povas enhavi miksitan stakon da aĵoj",
  "item.minecraft.bundle.full": "Plena",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Potpeco «Flamo»",
  "item.minecraft.burn_pottery_sherd": "Potpeco «Flamo»",
  "item.minecraft.camel_husk_spawn_egg": "Aperigovo de seka kamelo",
  "item.minecraft.camel_spawn_egg": "Aperigovo de kamelo",
  "item.minecraft.carrot": "Karoto",
  "item.minecraft.carrot_on_a_stick": "Fiŝkaptilo kun karoto",
  "item.minecraft.cat_spawn_egg": "Aperigovo de kato",
  "item.minecraft.cauldron": "Kaldrono",
  "item.minecraft.cave_spider_spawn_egg": "Aperigovo de kavernaraneo",
  "item.minecraft.chainmail_boots": "Ĉenaj botoj",
  "item.minecraft.chainmail_chestplate": "Ĉena kiraso",
  "item.minecraft.chainmail_helmet": "Ĉena kasko",
  "item.minecraft.chainmail_leggings": "Ĉenaj kruringoj",
  "item.minecraft.charcoal": "Lignokarbo",
  "item.minecraft.cherry_boat": "Sakura boato",
  "item.minecraft.cherry_chest_boat": "Sakura boato kun kofro",
  "item.minecraft.chest_minecart": "Vagoneto kun kofro",
  "item.minecraft.chicken": "Kruda kokaĵo",
  "item.minecraft.chicken_spawn_egg": "Aperigovo de koko",
  "item.minecraft.chorus_fruit": "Refrena frukto",
  "item.minecraft.clay_ball": "Argilbulo",
  "item.minecraft.clock": "Horloĝo",
  "item.minecraft.coal": "Karbo",
  "item.minecraft.coast_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Inkrustaĵo «Marbordo»",
  "item.minecraft.cocoa_beans": "Kakao",
  "item.minecraft.cod": "Kruda moruo",
  "item.minecraft.cod_bucket": "Sitelo kun moruo",
  "item.minecraft.cod_spawn_egg": "Aperigovo de moruo",
  "item.minecraft.command_block_minecart": "Vagoneto kun komanda bloko",
  "item.minecraft.compass": "Kompaso",
  "item.minecraft.cooked_beef": "Bifsteko",
  "item.minecraft.cooked_chicken": "Kuirita kokaĵo",
  "item.minecraft.cooked_cod": "Kuirita moruo",
  "item.minecraft.cooked_mutton": "Kuirita ŝafaĵo",
  "item.minecraft.cooked_porkchop": "Kuirita porkaĵo",
  "item.minecraft.cooked_rabbit": "Kuirita kuniklaĵo",
  "item.minecraft.cooked_salmon": "Kuirita salmo",
  "item.minecraft.cookie": "Kekso",
  "item.minecraft.copper_axe": "Kupra hakilo",
  "item.minecraft.copper_boots": "Kupraj botoj",
  "item.minecraft.copper_chestplate": "Kupra kiraso",
  "item.minecraft.copper_golem_spawn_egg": "Aperigovo de kuprogolemo",
  "item.minecraft.copper_helmet": "Kupra kasko",
  "item.minecraft.copper_hoe": "Kupra sarkilo",
  "item.minecraft.copper_horse_armor": "Kupra ĉevala armaĵo",
  "item.minecraft.copper_ingot": "Kupra ingoto",
  "item.minecraft.copper_leggings": "Kupraj kruringoj",
  "item.minecraft.copper_nautilus_armor": "Kupra naŭtila armaĵo",
  "item.minecraft.copper_nugget": "Kuprobulo",
  "item.minecraft.copper_pickaxe": "Kupra pioĉo",
  "item.minecraft.copper_shovel": "Kupra fosilo",
  "item.minecraft.copper_spear": "Kupra lanco",
  "item.minecraft.copper_sword": "Kupra glavo",
  "item.minecraft.cow_spawn_egg": "Aperigovo de bovo",
  "item.minecraft.creaking_spawn_egg": "Aperigovo de krako",
  "item.minecraft.creeper_banner_pattern": "Standarda ŝablono",
  "item.minecraft.creeper_banner_pattern.desc": "Danĝero",
  "item.minecraft.creeper_banner_pattern.new": "Standarda ŝablono «Danĝero»",
  "item.minecraft.creeper_spawn_egg": "Aperigovo de Creeper",
  "item.minecraft.crossbow": "Arbalesto",
  "item.minecraft.crossbow.projectile": "Pafaĵo:",
  "item.minecraft.crossbow.projectile.multiple": "Pafaĵo: %s ×%s",
  "item.minecraft.crossbow.projectile.single": "Pafaĵo: %s",
  "item.minecraft.cyan_bundle": "Turkisa sako",
  "item.minecraft.cyan_dye": "Turkisa tinkturo",
  "item.minecraft.cyan_harness": "Turkisa jungilaro",
  "item.minecraft.danger_pottery_shard": "Potpeco «Danĝero»",
  "item.minecraft.danger_pottery_sherd": "Potpeco «Danĝero»",
  "item.minecraft.dark_oak_boat": "Malhelkverka boato",
  "item.minecraft.dark_oak_chest_boat": "Malhelkverka boato kun kofro",
  "item.minecraft.debug_stick": "Sencimiga bastono",
  "item.minecraft.debug_stick.empty": "%s ne havas proprietojn",
  "item.minecraft.debug_stick.select": "vi elektis «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» al %s",
  "item.minecraft.diamond": "Diamanto",
  "item.minecraft.diamond_axe": "Diamanta hakilo",
  "item.minecraft.diamond_boots": "Diamantaj botoj",
  "item.minecraft.diamond_chestplate": "Diamanta kiraso",
  "item.minecraft.diamond_helmet": "Diamanta kasko",
  "item.minecraft.diamond_hoe": "Diamanta sarkilo",
  "item.minecraft.diamond_horse_armor": "Diamanta ĉevala armaĵo",
  "item.minecraft.diamond_leggings": "Diamantaj kruringoj",
  "item.minecraft.diamond_nautilus_armor": "Diamanta naŭtila armaĵo",
  "item.minecraft.diamond_pickaxe": "Diamanta pioĉo",
  "item.minecraft.diamond_shovel": "Diamanta fosilo",
  "item.minecraft.diamond_spear": "Diamanta lanco",
  "item.minecraft.diamond_sword": "Diamanta glavo",
  "item.minecraft.disc_fragment_5": "Diska peco",
  "item.minecraft.disc_fragment_5.desc": "Sondisko — 5",
  "item.minecraft.dolphin_spawn_egg": "Aperigovo de delfeno",
  "item.minecraft.donkey_spawn_egg": "Aperigovo de azeno",
  "item.minecraft.dragon_breath": "Draka spiraĵo",
  "item.minecraft.dried_kelp": "Sekigita algo",
  "item.minecraft.drowned_spawn_egg": "Aperigovo de droninto",
  "item.minecraft.dune_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Inkrustaĵo «Duno»",
  "item.minecraft.echo_shard": "Eĥosplito",
  "item.minecraft.egg": "Ovo",
  "item.minecraft.elder_guardian_spawn_egg": "Aperigovo de pragardisto",
  "item.minecraft.elytra": "Elitroj",
  "item.minecraft.emerald": "Smeraldo",
  "item.minecraft.enchanted_book": "Sorĉita libro",
  "item.minecraft.enchanted_golden_apple": "Sorĉita ora pomo",
  "item.minecraft.end_crystal": "Endkristalo",
  "item.minecraft.ender_dragon_spawn_egg": "Aperigovo de Enderdrako",
  "item.minecraft.ender_eye": "Enderokulo",
  "item.minecraft.ender_pearl": "Enderperlo",
  "item.minecraft.enderman_spawn_egg": "Aperigovo de Enderman",
  "item.minecraft.endermite_spawn_egg": "Aperigovo de Endermite",
  "item.minecraft.evoker_spawn_egg": "Aperigovo de alvokisto",
  "item.minecraft.experience_bottle": "Botelo de sorĉado",
  "item.minecraft.explorer_pottery_shard": "Potpeco «Aventuro»",
  "item.minecraft.explorer_pottery_sherd": "Potpeco «Aventuro»",
  "item.minecraft.eye_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Inkrustaĵo «Okulo»",
  "item.minecraft.feather": "Plumo",
  "item.minecraft.fermented_spider_eye": "Fermentita okulo de araneo",
  "item.minecraft.field_masoned_banner_pattern": "Standarda ŝablono «Brikumo»",
  "item.minecraft.filled_map": "Mapo",
  "item.minecraft.fire_charge": "Fajrobulo",
  "item.minecraft.firework_rocket": "Artfajraĵa raketo",
  "item.minecraft.firework_rocket.flight": "Flugdaŭro:",
  "item.minecraft.firework_rocket.multiple_stars": "%s ×%s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Artfajraĵa stelo",
  "item.minecraft.firework_star.black": "Nigra",
  "item.minecraft.firework_star.blue": "Blua",
  "item.minecraft.firework_star.brown": "Bruna",
  "item.minecraft.firework_star.custom_color": "Agordita",
  "item.minecraft.firework_star.cyan": "Turkisa",
  "item.minecraft.firework_star.fade_to": "Foriĝas je",
  "item.minecraft.firework_star.flicker": "Sparko",
  "item.minecraft.firework_star.gray": "Griza",
  "item.minecraft.firework_star.green": "Verda",
  "item.minecraft.firework_star.light_blue": "Helblua",
  "item.minecraft.firework_star.light_gray": "Helgriza",
  "item.minecraft.firework_star.lime": "Helverda",
  "item.minecraft.firework_star.magenta": "Malva",
  "item.minecraft.firework_star.orange": "Oranĝkolora",
  "item.minecraft.firework_star.pink": "Rozkolora",
  "item.minecraft.firework_star.purple": "Violkolora",
  "item.minecraft.firework_star.red": "Ruĝa",
  "item.minecraft.firework_star.shape": "Nekonata formo",
  "item.minecraft.firework_star.shape.burst": "Splitiĝo",
  "item.minecraft.firework_star.shape.creeper": "Creepera formo",
  "item.minecraft.firework_star.shape.large_ball": "Granda bulo",
  "item.minecraft.firework_star.shape.small_ball": "Malgranda bulo",
  "item.minecraft.firework_star.shape.star": "Stela formo",
  "item.minecraft.firework_star.trail": "Poststrio",
  "item.minecraft.firework_star.white": "Blanka",
  "item.minecraft.firework_star.yellow": "Flava",
  "item.minecraft.fishing_rod": "Fiŝkaptilo",
  "item.minecraft.flint": "Siliko",
  "item.minecraft.flint_and_steel": "Fajrilo",
  "item.minecraft.flow_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Inkrustaĵo «Kirlo»",
  "item.minecraft.flow_banner_pattern": "Standarda ŝablono",
  "item.minecraft.flow_banner_pattern.desc": "Kirlo",
  "item.minecraft.flow_banner_pattern.new": "Standarda ŝablono «Kirlo»",
  "item.minecraft.flow_pottery_sherd": "Potpeco «Kirlo»",
  "item.minecraft.flower_banner_pattern": "Standarda ŝablono",
  "item.minecraft.flower_banner_pattern.desc": "Lilio",
  "item.minecraft.flower_banner_pattern.new": "Standarda ŝablono «Lilio»",
  "item.minecraft.flower_pot": "Florpoto",
  "item.minecraft.fox_spawn_egg": "Aperigovo de vulpo",
  "item.minecraft.friend_pottery_shard": "Potpeco «Samideano»",
  "item.minecraft.friend_pottery_sherd": "Potpeco «Samideano»",
  "item.minecraft.frog_spawn_egg": "Aperigovo de rano",
  "item.minecraft.furnace_minecart": "Vagoneto kun forno",
  "item.minecraft.ghast_spawn_egg": "Aperigovo de Ghast",
  "item.minecraft.ghast_tear": "Ghasta larmo",
  "item.minecraft.glass_bottle": "Vitra botelo",
  "item.minecraft.glistering_melon_slice": "Tranĉaĵo da brila akvomelono",
  "item.minecraft.globe_banner_pattern": "Standarda ŝablono",
  "item.minecraft.globe_banner_pattern.desc": "Terkubo",
  "item.minecraft.globe_banner_pattern.new": "Standarda ŝablono «Terkubo»",
  "item.minecraft.glow_berries": "Lumberoj",
  "item.minecraft.glow_ink_sac": "Sako da luminko",
  "item.minecraft.glow_item_frame": "Luma kadro",
  "item.minecraft.glow_squid_spawn_egg": "Aperigovo de lumkalmaro",
  "item.minecraft.glowstone_dust": "Lumpolvo",
  "item.minecraft.goat_horn": "Kapra korno",
  "item.minecraft.goat_spawn_egg": "Aperigovo de kapro",
  "item.minecraft.gold_ingot": "Ora ingoto",
  "item.minecraft.gold_nugget": "Orobulo",
  "item.minecraft.golden_apple": "Ora pomo",
  "item.minecraft.golden_axe": "Ora hakilo",
  "item.minecraft.golden_boots": "Oraj botoj",
  "item.minecraft.golden_carrot": "Ora karoto",
  "item.minecraft.golden_chestplate": "Ora kiraso",
  "item.minecraft.golden_helmet": "Ora kasko",
  "item.minecraft.golden_hoe": "Ora sarkilo",
  "item.minecraft.golden_horse_armor": "Ora ĉevala armaĵo",
  "item.minecraft.golden_leggings": "Oraj kruringoj",
  "item.minecraft.golden_nautilus_armor": "Ora naŭtila armaĵo",
  "item.minecraft.golden_pickaxe": "Ora pioĉo",
  "item.minecraft.golden_shovel": "Ora fosilo",
  "item.minecraft.golden_spear": "Ora lanco",
  "item.minecraft.golden_sword": "Ora glavo",
  "item.minecraft.gray_bundle": "Griza sako",
  "item.minecraft.gray_dye": "Griza tinkturo",
  "item.minecraft.gray_harness": "Griza jungilaro",
  "item.minecraft.green_bundle": "Verda sako",
  "item.minecraft.green_dye": "Verda tinkturo",
  "item.minecraft.green_harness": "Verda jungilaro",
  "item.minecraft.guardian_spawn_egg": "Aperigovo de gardisto",
  "item.minecraft.gunpowder": "Pulvo",
  "item.minecraft.guster_banner_pattern": "Standarda ŝablono",
  "item.minecraft.guster_banner_pattern.desc": "Zumo",
  "item.minecraft.guster_banner_pattern.new": "Standarda ŝablono «Zumo»",
  "item.minecraft.guster_pottery_sherd": "Potpeco «Zumo»",
  "item.minecraft.happy_ghast_spawn_egg": "Aperigovo de feliĉa Ghast",
  "item.minecraft.harness": "Jungilaro",
  "item.minecraft.heart_of_the_sea": "Kerno de la maro",
  "item.minecraft.heart_pottery_shard": "Potpeco «Koro»",
  "item.minecraft.heart_pottery_sherd": "Potpeco «Koro»",
  "item.minecraft.heartbreak_pottery_shard": "Potpeco «Korkrevo»",
  "item.minecraft.heartbreak_pottery_sherd": "Potpeco «Korkrevo»",
  "item.minecraft.hoglin_spawn_egg": "Aperigovo de Hoglin",
  "item.minecraft.honey_bottle": "Botelo da mielo",
  "item.minecraft.honeycomb": "Miela ĉelaro",
  "item.minecraft.hopper_minecart": "Vagoneto kun funelo",
  "item.minecraft.horse_spawn_egg": "Aperigovo de ĉevalo",
  "item.minecraft.host_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.host_armor_trim_smithing_template.new": "Inkrustaĵo «Estro»",
  "item.minecraft.howl_pottery_shard": "Potpeco «Hurlo»",
  "item.minecraft.howl_pottery_sherd": "Potpeco «Hurlo»",
  "item.minecraft.husk_spawn_egg": "Aperigovo de sekulo",
  "item.minecraft.ink_sac": "Inksako",
  "item.minecraft.iron_axe": "Fera hakilo",
  "item.minecraft.iron_boots": "Feraj botoj",
  "item.minecraft.iron_chestplate": "Fera kiraso",
  "item.minecraft.iron_golem_spawn_egg": "Aperigovo de fergolemo",
  "item.minecraft.iron_helmet": "Fera kasko",
  "item.minecraft.iron_hoe": "Fera sarkilo",
  "item.minecraft.iron_horse_armor": "Fera ĉevala armaĵo",
  "item.minecraft.iron_ingot": "Fera ingoto",
  "item.minecraft.iron_leggings": "Feraj kruringoj",
  "item.minecraft.iron_nautilus_armor": "Fera naŭtila armaĵo",
  "item.minecraft.iron_nugget": "Ferobulo",
  "item.minecraft.iron_pickaxe": "Fera pioĉo",
  "item.minecraft.iron_shovel": "Fera fosilo",
  "item.minecraft.iron_spear": "Fera lanco",
  "item.minecraft.iron_sword": "Fera glavo",
  "item.minecraft.item_frame": "Kadro",
  "item.minecraft.jungle_boat": "Ĝangalarba boato",
  "item.minecraft.jungle_chest_boat": "Ĝangalarba boato kun kofro",
  "item.minecraft.knowledge_book": "Libro de sciado",
  "item.minecraft.lapis_lazuli": "Lazurito",
  "item.minecraft.lava_bucket": "Sitelo da lafo",
  "item.minecraft.lead": "Kondukilo",
  "item.minecraft.leather": "Ledo",
  "item.minecraft.leather_boots": "Ledaj botoj",
  "item.minecraft.leather_chestplate": "Leda tuniko",
  "item.minecraft.leather_helmet": "Leda ĉapo",
  "item.minecraft.leather_horse_armor": "Leda ĉevala armaĵo",
  "item.minecraft.leather_leggings": "Leda pantalono",
  "item.minecraft.light_blue_bundle": "Helblua sako",
  "item.minecraft.light_blue_dye": "Helblua tinkturo",
  "item.minecraft.light_blue_harness": "Helblua jungilaro",
  "item.minecraft.light_gray_bundle": "Helgriza sako",
  "item.minecraft.light_gray_dye": "Helgriza tinkturo",
  "item.minecraft.light_gray_harness": "Helgriza jungilaro",
  "item.minecraft.lime_bundle": "Helverda sako",
  "item.minecraft.lime_dye": "Helverda tinkturo",
  "item.minecraft.lime_harness": "Helverda jungilaro",
  "item.minecraft.lingering_potion": "Resta eliksiro",
  "item.minecraft.lingering_potion.effect.awkward": "Stranga resta eliksiro",
  "item.minecraft.lingering_potion.effect.empty": "Resta nefarebla eliksiro",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Resta eliksiro de fajrorezisto",
  "item.minecraft.lingering_potion.effect.harming": "Resta eliksiro de lezado",
  "item.minecraft.lingering_potion.effect.healing": "Resta eliksiro de sanigo",
  "item.minecraft.lingering_potion.effect.infested": "Resta eliksiro de infesto",
  "item.minecraft.lingering_potion.effect.invisibility": "Resta eliksiro de nevidebleco",
  "item.minecraft.lingering_potion.effect.leaping": "Resta eliksiro de saltado",
  "item.minecraft.lingering_potion.effect.levitation": "Resta eliksiro de levitacio",
  "item.minecraft.lingering_potion.effect.luck": "Resta eliksiro de bonŝanco",
  "item.minecraft.lingering_potion.effect.mundane": "Banala resta eliksiro",
  "item.minecraft.lingering_potion.effect.night_vision": "Resta eliksiro de noktvido",
  "item.minecraft.lingering_potion.effect.oozing": "Resta eliksiro de sekrecio",
  "item.minecraft.lingering_potion.effect.poison": "Resta eliksiro de veneno",
  "item.minecraft.lingering_potion.effect.regeneration": "Resta eliksiro de resanigado",
  "item.minecraft.lingering_potion.effect.slow_falling": "Resta eliksiro de malrapida falo",
  "item.minecraft.lingering_potion.effect.slowness": "Resta eliksiro de malrapideco",
  "item.minecraft.lingering_potion.effect.strength": "Resta eliksiro de forteco",
  "item.minecraft.lingering_potion.effect.swiftness": "Resta eliksiro de rapideco",
  "item.minecraft.lingering_potion.effect.thick": "Densa resta eliksiro",
  "item.minecraft.lingering_potion.effect.turtle_master": "Resta eliksiro de la testudmajstro",
  "item.minecraft.lingering_potion.effect.water": "Resta botelo da akvo",
  "item.minecraft.lingering_potion.effect.water_breathing": "Resta eliksiro de submarspirado",
  "item.minecraft.lingering_potion.effect.weakness": "Resta eliksiro de malforteco",
  "item.minecraft.lingering_potion.effect.weaving": "Resta eliksiro de plektemo",
  "item.minecraft.lingering_potion.effect.wind_charged": "Resta eliksiro de ventonteco",
  "item.minecraft.llama_spawn_egg": "Aperigovo de lamo",
  "item.minecraft.lodestone_compass": "Magnetigita kompaso",
  "item.minecraft.mace": "Madzo",
  "item.minecraft.magenta_bundle": "Malva sako",
  "item.minecraft.magenta_dye": "Malva tinkturo",
  "item.minecraft.magenta_harness": "Malva jungilaro",
  "item.minecraft.magma_cream": "Magmokremo",
  "item.minecraft.magma_cube_spawn_egg": "Aperigovo de magmokubo",
  "item.minecraft.mangrove_boat": "Mangla boato",
  "item.minecraft.mangrove_chest_boat": "Mangla boato kun kofro",
  "item.minecraft.map": "Blanka mapo",
  "item.minecraft.melon_seeds": "Akvomelonaj semoj",
  "item.minecraft.melon_slice": "Akvomelontranĉaĵo",
  "item.minecraft.milk_bucket": "Sitelo da lakto",
  "item.minecraft.minecart": "Vagoneto",
  "item.minecraft.miner_pottery_shard": "Potpeco «Pioĉo»",
  "item.minecraft.miner_pottery_sherd": "Potpeco «Pioĉo»",
  "item.minecraft.mojang_banner_pattern": "Standarda ŝablono",
  "item.minecraft.mojang_banner_pattern.desc": "Umo",
  "item.minecraft.mojang_banner_pattern.new": "Standarda ŝablono «Umo»",
  "item.minecraft.mooshroom_spawn_egg": "Aperigovo de Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Potpeco «Jelpo»",
  "item.minecraft.mourner_pottery_sherd": "Potpeco «Jelpo»",
  "item.minecraft.mule_spawn_egg": "Aperigovo de mulo",
  "item.minecraft.mushroom_stew": "Fungosupo",
  "item.minecraft.music_disc_11": "Sondisko",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Sondisko",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Sondisko",
  "item.minecraft.music_disc_5.desc": "Samuel Åʙᴇʀɢ — 5",
  "item.minecraft.music_disc_blocks": "Sondisko",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Sondisko",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Sondisko",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Sondisko",
  "item.minecraft.music_disc_creator.desc": "Lena Rᴀɪɴᴇ — Creator",
  "item.minecraft.music_disc_creator_music_box": "Sondisko",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Rᴀɪɴᴇ — Creator (muzikskatolo)",
  "item.minecraft.music_disc_far": "Sondisko",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Sondisko",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Sondisko",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Sondisko",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Sondisko",
  "item.minecraft.music_disc_otherside.desc": "Lena Rᴀɪɴᴇ — otherside",
  "item.minecraft.music_disc_pigstep": "Sondisko",
  "item.minecraft.music_disc_pigstep.desc": "Lena Rᴀɪɴᴇ — Pigstep",
  "item.minecraft.music_disc_precipice": "Sondisko",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cʜᴇʀᴏꜰ — Precipice",
  "item.minecraft.music_disc_relic": "Sondisko",
  "item.minecraft.music_disc_relic.desc": "Aaron Cʜᴇʀᴏꜰ — Relic",
  "item.minecraft.music_disc_stal": "Sondisko",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Sondisko",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Sondisko",
  "item.minecraft.music_disc_tears.desc": "Amos Rᴏᴅᴅʏ — Tears",
  "item.minecraft.music_disc_wait": "Sondisko",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Sondisko",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Kruda ŝafaĵo",
  "item.minecraft.name_tag": "Nomilo",
  "item.minecraft.nautilus_shell": "Naŭtila konko",
  "item.minecraft.nautilus_spawn_egg": "Aperigovo de naŭtilo",
  "item.minecraft.nether_brick": "Netherbriko",
  "item.minecraft.nether_star": "Nethera stelo",
  "item.minecraft.nether_wart": "Nethera veruko",
  "item.minecraft.netherite_axe": "Netherite’a hakilo",
  "item.minecraft.netherite_boots": "Netherite’aj botoj",
  "item.minecraft.netherite_chestplate": "Netherite’a kiraso",
  "item.minecraft.netherite_helmet": "Netherite’a kasko",
  "item.minecraft.netherite_hoe": "Netherite’a sarkilo",
  "item.minecraft.netherite_horse_armor": "Netherite’a ĉevala armaĵo",
  "item.minecraft.netherite_ingot": "Netherite’a ingoto",
  "item.minecraft.netherite_leggings": "Netherite’aj kruringoj",
  "item.minecraft.netherite_nautilus_armor": "Netherite’a naŭtila armaĵo",
  "item.minecraft.netherite_pickaxe": "Netherite’a pioĉo",
  "item.minecraft.netherite_scrap": "Netherite’a fragmento",
  "item.minecraft.netherite_shovel": "Netherite’a fosilo",
  "item.minecraft.netherite_spear": "Netherite’a lanco",
  "item.minecraft.netherite_sword": "Netherite’a glavo",
  "item.minecraft.netherite_upgrade_smithing_template": "Forĝa ŝablono",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite’umo",
  "item.minecraft.oak_boat": "Kverka boato",
  "item.minecraft.oak_chest_boat": "Kverka boato kun kofro",
  "item.minecraft.ocelot_spawn_egg": "Aperigovo de oceloto",
  "item.minecraft.ominous_bottle": "Makabra botelo",
  "item.minecraft.ominous_trial_key": "Makabra defia malŝlosilo",
  "item.minecraft.orange_bundle": "Oranĝkolora sako",
  "item.minecraft.orange_dye": "Oranĝkolora tinkturo",
  "item.minecraft.orange_harness": "Oranĝkolora jungilaro",
  "item.minecraft.painting": "Pentraĵo",
  "item.minecraft.pale_oak_boat": "Helkverka boato",
  "item.minecraft.pale_oak_chest_boat": "Helkverka boato kun kofro",
  "item.minecraft.panda_spawn_egg": "Aperigovo de pando",
  "item.minecraft.paper": "Papero",
  "item.minecraft.parched_spawn_egg": "Aperigovo de soifanto",
  "item.minecraft.parrot_spawn_egg": "Aperigovo de papago",
  "item.minecraft.phantom_membrane": "Fantoma membrano",
  "item.minecraft.phantom_spawn_egg": "Aperigovo de fantomo",
  "item.minecraft.pig_spawn_egg": "Aperigovo de porko",
  "item.minecraft.piglin_banner_pattern": "Standarda ŝablono",
  "item.minecraft.piglin_banner_pattern.desc": "Rostro",
  "item.minecraft.piglin_banner_pattern.new": "Standarda ŝablono «Rostro»",
  "item.minecraft.piglin_brute_spawn_egg": "Aperigovo de brutala Piglin",
  "item.minecraft.piglin_spawn_egg": "Aperigovo de Piglin",
  "item.minecraft.pillager_spawn_egg": "Aperigovo de rabisto",
  "item.minecraft.pink_bundle": "Rozkolora sako",
  "item.minecraft.pink_dye": "Rozkolora tinkturo",
  "item.minecraft.pink_harness": "Rozkolora jungilaro",
  "item.minecraft.pitcher_plant": "Kruĉenio",
  "item.minecraft.pitcher_pod": "Kruĉenia guŝo",
  "item.minecraft.plenty_pottery_shard": "Potpeco «Trezoro»",
  "item.minecraft.plenty_pottery_sherd": "Potpeco «Trezoro»",
  "item.minecraft.poisonous_potato": "Venena terpomo",
  "item.minecraft.polar_bear_spawn_egg": "Aperigovo de blanka urso",
  "item.minecraft.popped_chorus_fruit": "Krevita refrena frukto",
  "item.minecraft.porkchop": "Kruda porkaĵo",
  "item.minecraft.potato": "Terpomo",
  "item.minecraft.potion": "Eliksiro",
  "item.minecraft.potion.effect.awkward": "Stranga eliksiro",
  "item.minecraft.potion.effect.empty": "Nefarebla eliksiro",
  "item.minecraft.potion.effect.fire_resistance": "Eliksiro de fajrorezisto",
  "item.minecraft.potion.effect.harming": "Eliksiro de lezado",
  "item.minecraft.potion.effect.healing": "Eliksiro de sanigo",
  "item.minecraft.potion.effect.infested": "Eliksiro de infesto",
  "item.minecraft.potion.effect.invisibility": "Eliksiro de nevidebleco",
  "item.minecraft.potion.effect.leaping": "Eliksiro de saltado",
  "item.minecraft.potion.effect.levitation": "Eliksiro de levitacio",
  "item.minecraft.potion.effect.luck": "Eliksiro de bonŝanco",
  "item.minecraft.potion.effect.mundane": "Banala eliksiro",
  "item.minecraft.potion.effect.night_vision": "Eliksiro de noktvido",
  "item.minecraft.potion.effect.oozing": "Eliksiro de sekrecio",
  "item.minecraft.potion.effect.poison": "Eliksiro de veneno",
  "item.minecraft.potion.effect.regeneration": "Eliksiro de resanigado",
  "item.minecraft.potion.effect.slow_falling": "Eliksiro de malrapida falo",
  "item.minecraft.potion.effect.slowness": "Eliksiro de malrapideco",
  "item.minecraft.potion.effect.strength": "Eliksiro de forteco",
  "item.minecraft.potion.effect.swiftness": "Eliksiro de rapideco",
  "item.minecraft.potion.effect.thick": "Densa eliksiro",
  "item.minecraft.potion.effect.turtle_master": "Eliksiro de la testudmajstro",
  "item.minecraft.potion.effect.water": "Botelo da akvo",
  "item.minecraft.potion.effect.water_breathing": "Eliksiro de submarspirado",
  "item.minecraft.potion.effect.weakness": "Eliksiro de malforteco",
  "item.minecraft.potion.effect.weaving": "Eliksiro de plektemo",
  "item.minecraft.potion.effect.wind_charged": "Eliksiro de ventonteco",
  "item.minecraft.pottery_shard_archer": "Potpeco «Pafarko»",
  "item.minecraft.pottery_shard_arms_up": "Potpeco «Manlevo»",
  "item.minecraft.pottery_shard_prize": "Potpeco «Brilianto»",
  "item.minecraft.pottery_shard_skull": "Potpeco «Kranio»",
  "item.minecraft.powder_snow_bucket": "Sitelo da pulvora neĝo",
  "item.minecraft.prismarine_crystals": "Prismarina kristalo",
  "item.minecraft.prismarine_shard": "Prismarina splito",
  "item.minecraft.prize_pottery_shard": "Potpeco «Brilianto»",
  "item.minecraft.prize_pottery_sherd": "Potpeco «Brilianto»",
  "item.minecraft.pufferfish": "Pintfiŝo",
  "item.minecraft.pufferfish_bucket": "Sitelo kun pintfiŝo",
  "item.minecraft.pufferfish_spawn_egg": "Aperigovo de pintfiŝo",
  "item.minecraft.pumpkin_pie": "Kukurba kuko",
  "item.minecraft.pumpkin_seeds": "Kukurbaj semoj",
  "item.minecraft.purple_bundle": "Violkolora sako",
  "item.minecraft.purple_dye": "Violkolora tinkturo",
  "item.minecraft.purple_harness": "Violkolora jungilaro",
  "item.minecraft.quartz": "Kvarco",
  "item.minecraft.rabbit": "Kruda kuniklaĵo",
  "item.minecraft.rabbit_foot": "Kunikla piedo",
  "item.minecraft.rabbit_hide": "Kunikla felo",
  "item.minecraft.rabbit_spawn_egg": "Aperigovo de kuniklo",
  "item.minecraft.rabbit_stew": "Kuniklaĵa raguo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Inkrustaĵo «Kolektisto»",
  "item.minecraft.ravager_spawn_egg": "Aperigovo de ruiniganto",
  "item.minecraft.raw_copper": "Kruda kupro",
  "item.minecraft.raw_gold": "Kruda oro",
  "item.minecraft.raw_iron": "Kruda fero",
  "item.minecraft.recovery_compass": "Revenkompaso",
  "item.minecraft.red_bundle": "Ruĝa sako",
  "item.minecraft.red_dye": "Ruĝa tinkturo",
  "item.minecraft.red_harness": "Ruĝa jungilaro",
  "item.minecraft.redstone": "Redstone’a polvo",
  "item.minecraft.resin_brick": "Rezina briko",
  "item.minecraft.resin_clump": "Rezina koagulaĵo",
  "item.minecraft.rib_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Inkrustaĵo «Ripoj»",
  "item.minecraft.rotten_flesh": "Putra karno",
  "item.minecraft.saddle": "Selo",
  "item.minecraft.salmon": "Kruda salmo",
  "item.minecraft.salmon_bucket": "Sitelo kun salmo",
  "item.minecraft.salmon_spawn_egg": "Aperigovo de salmo",
  "item.minecraft.scrape_pottery_sherd": "Potpeco «Skrapo»",
  "item.minecraft.scute": "Ŝelero",
  "item.minecraft.sentry_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Inkrustaĵo «Sentinelo»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Inkrustaĵo «Tornisto»",
  "item.minecraft.sheaf_pottery_shard": "Potpeco «Garbo»",
  "item.minecraft.sheaf_pottery_sherd": "Potpeco «Garbo»",
  "item.minecraft.shears": "Tondilo",
  "item.minecraft.sheep_spawn_egg": "Aperigovo de ŝafo",
  "item.minecraft.shelter_pottery_shard": "Potpeco «Ombrejo»",
  "item.minecraft.shelter_pottery_sherd": "Potpeco «Ombrejo»",
  "item.minecraft.shield": "Ŝildo",
  "item.minecraft.shield.black": "Nigra ŝildo",
  "item.minecraft.shield.blue": "Blua ŝildo",
  "item.minecraft.shield.brown": "Bruna ŝildo",
  "item.minecraft.shield.cyan": "Turkisa ŝildo",
  "item.minecraft.shield.gray": "Griza ŝildo",
  "item.minecraft.shield.green": "Verda ŝildo",
  "item.minecraft.shield.light_blue": "Helblua ŝildo",
  "item.minecraft.shield.light_gray": "Helgriza ŝildo",
  "item.minecraft.shield.lime": "Helverda ŝildo",
  "item.minecraft.shield.magenta": "Malva ŝildo",
  "item.minecraft.shield.orange": "Oranĝkolora ŝildo",
  "item.minecraft.shield.pink": "Rozkolora ŝildo",
  "item.minecraft.shield.purple": "Violkolora ŝildo",
  "item.minecraft.shield.red": "Ruĝa ŝildo",
  "item.minecraft.shield.white": "Blanka ŝildo",
  "item.minecraft.shield.yellow": "Flava ŝildo",
  "item.minecraft.shulker_shell": "Ŝelo de Shulker",
  "item.minecraft.shulker_spawn_egg": "Aperigovo de Shulker",
  "item.minecraft.sign": "Ŝildeto",
  "item.minecraft.silence_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Inkrustaĵo «Silento»",
  "item.minecraft.silverfish_spawn_egg": "Aperigovo de lepismo",
  "item.minecraft.skeleton_horse_spawn_egg": "Aperigovo de skeleta ĉevalo",
  "item.minecraft.skeleton_spawn_egg": "Aperigovo de skeleto",
  "item.minecraft.skull_banner_pattern": "Standarda ŝablono",
  "item.minecraft.skull_banner_pattern.desc": "Kranio",
  "item.minecraft.skull_banner_pattern.new": "Standarda ŝablono «Kranio»",
  "item.minecraft.skull_pottery_shard": "Potpeco «Kranio»",
  "item.minecraft.skull_pottery_sherd": "Potpeco «Kranio»",
  "item.minecraft.slime_ball": "Mukbulo",
  "item.minecraft.slime_spawn_egg": "Aperigovo de mukokubo",
  "item.minecraft.smithing_template": "Forĝa ŝablono",
  "item.minecraft.smithing_template.applies_to": "Aplikebla al",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Metu ĉi tien ingoton aŭ kristalon",
  "item.minecraft.smithing_template.armor_trim.applies_to": "armaĵo",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Metu ĉi tien armaĵpecon",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingotoj k kristaloj",
  "item.minecraft.smithing_template.ingredients": "Materialoj:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Metu ĉi tien Netherite’an ingoton",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantaĵoj",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Metu ĉi tien diamantan armaĵpecon aŭ ilon",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite’a ingoto",
  "item.minecraft.smithing_template.upgrade": "Plibonigo: ",
  "item.minecraft.sniffer_spawn_egg": "Aperigovo de snuflaro",
  "item.minecraft.snort_pottery_shard": "Potpeco «Snufo»",
  "item.minecraft.snort_pottery_sherd": "Potpeco «Snufo»",
  "item.minecraft.snout_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Inkrustaĵo «Rostro»",
  "item.minecraft.snow_golem_spawn_egg": "Aperigovo de neĝgolemo",
  "item.minecraft.snowball": "Neĝbulo",
  "item.minecraft.spectral_arrow": "Spektra sago",
  "item.minecraft.spider_eye": "Okulo de araneo",
  "item.minecraft.spider_spawn_egg": "Aperigovo de araneo",
  "item.minecraft.spire_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Inkrustaĵo «Stango»",
  "item.minecraft.splash_potion": "Ŝpruca eliksiro",
  "item.minecraft.splash_potion.effect.awkward": "Stranga ŝpruca eliksiro",
  "item.minecraft.splash_potion.effect.empty": "Ŝpruca nefarebla eliksiro",
  "item.minecraft.splash_potion.effect.fire_resistance": "Ŝpruca eliksiro de fajrorezisto",
  "item.minecraft.splash_potion.effect.harming": "Ŝpruca eliksiro de lezado",
  "item.minecraft.splash_potion.effect.healing": "Ŝpruca eliksiro de sanigo",
  "item.minecraft.splash_potion.effect.infested": "Ŝpruca eliksiro de infesto",
  "item.minecraft.splash_potion.effect.invisibility": "Ŝpruca eliksiro de nevidebleco",
  "item.minecraft.splash_potion.effect.leaping": "Ŝpruca eliksiro de saltado",
  "item.minecraft.splash_potion.effect.levitation": "Ŝpruca eliksiro de levitacio",
  "item.minecraft.splash_potion.effect.luck": "Ŝpruca eliksiro de bonŝanco",
  "item.minecraft.splash_potion.effect.mundane": "Banala ŝpruca eliksiro",
  "item.minecraft.splash_potion.effect.night_vision": "Ŝpruca eliksiro de noktvido",
  "item.minecraft.splash_potion.effect.oozing": "Ŝpruca eliksiro de sekrecio",
  "item.minecraft.splash_potion.effect.poison": "Ŝpruca eliksiro de veneno",
  "item.minecraft.splash_potion.effect.regeneration": "Ŝpruca eliksiro de resanigado",
  "item.minecraft.splash_potion.effect.slow_falling": "Ŝpruca eliksiro de malrapida falo",
  "item.minecraft.splash_potion.effect.slowness": "Ŝpruca eliksiro de malrapideco",
  "item.minecraft.splash_potion.effect.strength": "Ŝpruca eliksiro de forteco",
  "item.minecraft.splash_potion.effect.swiftness": "Ŝpruca eliksiro de rapideco",
  "item.minecraft.splash_potion.effect.thick": "Densa ŝpruca eliksiro",
  "item.minecraft.splash_potion.effect.turtle_master": "Ŝpruca eliksiro de la testudmajstro",
  "item.minecraft.splash_potion.effect.water": "Ŝpruca botelo da akvo",
  "item.minecraft.splash_potion.effect.water_breathing": "Ŝpruca eliksiro de submarspirado",
  "item.minecraft.splash_potion.effect.weakness": "Ŝpruca eliksiro de malforteco",
  "item.minecraft.splash_potion.effect.weaving": "Ŝpruca eliksiro de plektemo",
  "item.minecraft.splash_potion.effect.wind_charged": "Ŝpruca eliksiro de ventonteco",
  "item.minecraft.spruce_boat": "Picea boato",
  "item.minecraft.spruce_chest_boat": "Picea boato kun kofro",
  "item.minecraft.spyglass": "Lorno",
  "item.minecraft.squid_spawn_egg": "Aperigovo de kalmaro",
  "item.minecraft.stick": "Bastono",
  "item.minecraft.stone_axe": "Ŝtona hakilo",
  "item.minecraft.stone_hoe": "Ŝtona sarkilo",
  "item.minecraft.stone_pickaxe": "Ŝtona pioĉo",
  "item.minecraft.stone_shovel": "Ŝtona fosilo",
  "item.minecraft.stone_spear": "Ŝtona lanco",
  "item.minecraft.stone_sword": "Ŝtona glavo",
  "item.minecraft.stray_spawn_egg": "Aperigovo de devojiĝinto",
  "item.minecraft.strider_spawn_egg": "Aperigovo de lafpaŝanto",
  "item.minecraft.string": "Fadeno",
  "item.minecraft.sugar": "Sukero",
  "item.minecraft.suspicious_stew": "Suspektinda manĝaĵo",
  "item.minecraft.sweet_berries": "Dolĉberoj",
  "item.minecraft.tadpole_bucket": "Sitelo kun ranido",
  "item.minecraft.tadpole_spawn_egg": "Aperigovo de ranido",
  "item.minecraft.tide_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Inkrustaĵo «Tajdo»",
  "item.minecraft.tipped_arrow": "Eliksira sago",
  "item.minecraft.tipped_arrow.effect.awkward": "Eliksira sago",
  "item.minecraft.tipped_arrow.effect.empty": "Nefarebla eliksira sago",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Sago de fajrorezisto",
  "item.minecraft.tipped_arrow.effect.harming": "Sago de lezado",
  "item.minecraft.tipped_arrow.effect.healing": "Sago de sanigo",
  "item.minecraft.tipped_arrow.effect.infested": "Sago de infesto",
  "item.minecraft.tipped_arrow.effect.invisibility": "Sago de nevidebleco",
  "item.minecraft.tipped_arrow.effect.leaping": "Sago de saltado",
  "item.minecraft.tipped_arrow.effect.levitation": "Sago de ŝvebado",
  "item.minecraft.tipped_arrow.effect.luck": "Sago de bonŝanco",
  "item.minecraft.tipped_arrow.effect.mundane": "Eliksira sago",
  "item.minecraft.tipped_arrow.effect.night_vision": "Sago de noktvido",
  "item.minecraft.tipped_arrow.effect.oozing": "Sago de sekrecio",
  "item.minecraft.tipped_arrow.effect.poison": "Sago de veneno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Sago de resanigado",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Sago de malrapida falo",
  "item.minecraft.tipped_arrow.effect.slowness": "Sago de malrapideco",
  "item.minecraft.tipped_arrow.effect.strength": "Sago de forteco",
  "item.minecraft.tipped_arrow.effect.swiftness": "Sago de rapideco",
  "item.minecraft.tipped_arrow.effect.thick": "Eliksira sago",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Sago de la testudmajstro",
  "item.minecraft.tipped_arrow.effect.water": "Sago de ŝprucado",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Sago de submarspirado",
  "item.minecraft.tipped_arrow.effect.weakness": "Sago de malforteco",
  "item.minecraft.tipped_arrow.effect.weaving": "Sago de plektemo",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Sago de ventonteco",
  "item.minecraft.tnt_minecart": "Vagoneto kun TNT",
  "item.minecraft.torchflower_seeds": "Torĉfloraj semoj",
  "item.minecraft.totem_of_undying": "Totemo de senmorteco",
  "item.minecraft.trader_llama_spawn_egg": "Aperigovo de vendista lamo",
  "item.minecraft.trial_key": "Defia malŝlosilo",
  "item.minecraft.trident": "Tridento",
  "item.minecraft.tropical_fish": "Tropika fiŝo",
  "item.minecraft.tropical_fish_bucket": "Sitelo kun tropika fiŝo",
  "item.minecraft.tropical_fish_spawn_egg": "Aperigovo de tropika fiŝo",
  "item.minecraft.turtle_helmet": "Testuda ŝelo",
  "item.minecraft.turtle_scute": "Ŝelero de testudo",
  "item.minecraft.turtle_spawn_egg": "Aperigovo de testudo",
  "item.minecraft.vex_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Inkrustaĵo «Alvokisto»",
  "item.minecraft.vex_spawn_egg": "Aperigovo de molestulo",
  "item.minecraft.villager_spawn_egg": "Aperigovo de vilaĝano",
  "item.minecraft.vindicator_spawn_egg": "Aperigovo de praviganto",
  "item.minecraft.wandering_trader_spawn_egg": "Aperigovo de vaganta vendisto",
  "item.minecraft.ward_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Inkrustaĵo «Abismo»",
  "item.minecraft.warden_spawn_egg": "Aperigovo de provoso",
  "item.minecraft.warped_fungus_on_a_stick": "Fiŝkaptilo kun torda fungo",
  "item.minecraft.water_bucket": "Sitelo da akvo",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Inkrustaĵo «Vojserĉo»",
  "item.minecraft.wheat": "Tritiko",
  "item.minecraft.wheat_seeds": "Tritikaj semoj",
  "item.minecraft.white_bundle": "Blanka sako",
  "item.minecraft.white_dye": "Blanka tinkturo",
  "item.minecraft.white_harness": "Blanka jungilaro",
  "item.minecraft.wild_armor_trim_smithing_template": "Forĝa ŝablono",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Inkrustaĵo «Plektokreskaĵo»",
  "item.minecraft.wind_charge": "Ventobulo",
  "item.minecraft.witch_spawn_egg": "Aperigovo de sorĉistino",
  "item.minecraft.wither_skeleton_spawn_egg": "Aperigovo de Witherskeleto",
  "item.minecraft.wither_spawn_egg": "Aperigovo de Wither",
  "item.minecraft.wolf_armor": "Lupa armaĵo",
  "item.minecraft.wolf_spawn_egg": "Aperigovo de lupo",
  "item.minecraft.wooden_axe": "Ligna hakilo",
  "item.minecraft.wooden_hoe": "Ligna sarkilo",
  "item.minecraft.wooden_pickaxe": "Ligna pioĉo",
  "item.minecraft.wooden_shovel": "Ligna fosilo",
  "item.minecraft.wooden_spear": "Ligna lanco",
  "item.minecraft.wooden_sword": "Ligna glavo",
  "item.minecraft.writable_book": "Libro kaj plumo",
  "item.minecraft.written_book": "Skribita libro",
  "item.minecraft.yellow_bundle": "Flava sako",
  "item.minecraft.yellow_dye": "Flava tinkturo",
  "item.minecraft.yellow_harness": "Flava jungilaro",
  "item.minecraft.zoglin_spawn_egg": "Aperigovo de Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Aperigovo de zombia ĉevalo",
  "item.minecraft.zombie_nautilus_spawn_egg": "Aperigovo de zombia naŭtilo",
  "item.minecraft.zombie_spawn_egg": "Aperigovo de zombio",
  "item.minecraft.zombie_villager_spawn_egg": "Aperigovo de zombia vilaĝano",
  "item.minecraft.zombified_piglin_spawn_egg": "Aperigovo de zombia Piglin"
}
export const eo_uy = items; 
